import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { showLoading } from 'react-global-loading';
import { toast, ToastContainer } from 'react-toastify';
import { isNumeric } from '../../../../Custom/Custom';
import messages from '../../../../assets/Messages.json';
import asiTitle from '../../../../asi.json';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-toastify/dist/ReactToastify.css';
import { API_URL } from '../../../../Constant';
import Remarks__list from './Remarks__list';
import StatusUnitDropdown from '../../../../Components/Block/StatusUnitDropdown';
import IndustryCodeReturnDropdown from '../../../../Components/Block/IndustryCodeReturnDropdown';
import { markPageAsSaved, PAGE_NAMES, refreshBalanceSheetValidation, clearSavedPages } from '../../../../Components/BalanceSheet/BalanceSheetHeader';
import { filterRemarksList } from '../../../../Custom/Custom';
import { jwtDecode } from 'jwt-decode';


function BalanceSheet() {
  const navigate = useNavigate();


  const [formData, setFormData] = useState({
    year: '',
    scheduleDespatchNo: '',
    pslNo: '',
    schemeCode: '',
    industryCodeFrame: '',
    industryCodeReturn: '',
    descriptionOfIndustry: '',
    state: '',
    stateCode: '',
    district: '',
    sector: '',
    roSroCode: '',
    numberOfUnits: '',
    statusOfUnit: '',
    nameUnit: '',
    addressUnit: '',
    villTown: '',
    districtName: '',
    stateName: '',
    pinCode: '',
    emailId: '',
    mobileNumber: '',
    typeOfOrg: '',
    hasCIN: '',
    cin: '',
    isoCert: '',
    yearOfInitialProd: '',
    accountingYearFrom: '',
    accountingYearTo: '',
    monthsOfOperation: '',
    shareCapital: '',
    rdUnit: '',
    rdMaleEmployees: '',
    rdFemaleEmployees: '',
    rdTransgenderEmployees: '',
    contactName: '',
    contactTele: '',
    contactFax: '',
    contactEmail: '',
    contactPersonName: '',
    contactPersonDesignation: '',
    contactPersonEmail: '',
    contactPersonMobile: '',
    formalTraining: '',
    trainingMaleEmployees: '',
    trainingFemaleEmployees: '',
    trainingTransgenderEmployees: '',
    gstin: '',
    dslNo: '',
    verificationCompilationDate: '',
    entryMode: 'balanceSheet',
    documentPath: '',
    documentPathFull: '',
    uploadScheduleFileName: '',
    uploadScheduleFilePath: '',
    remarksBlock: '',
    remarksItems: '',
    remarks: '',
  });

  // Date picker states
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [verificationDate, setVerificationDate] = useState(null);
  const today = new Date();

  // File upload state
  const [uploadedFile, setUploadedFile] = useState(null);
  const [uploadScheduleFile, setUploadScheduleFile] = useState(null);

  // Error state for form validation
  const [errors, setErrors] = useState({
    contactEmail: '',
    cin: ''
  });

  // Loading and API call states
  const [isApiLoading, setIsApiLoading] = useState(false);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const apiCallRef = useRef(null);
  const lastApiCallRef = useRef({ dslNo: '', year: '' });
  const descriptionRef = useRef(null);
  const toastShownRef = useRef({});
  const buttonClickRef = useRef({ isProcessing: false });

  const [industryCodeReturnList, setIndustryCodeReturnList] = useState([]);
  const [unitCodes, setUnitCodes] = useState([]);
  const [remarksList, setRemarksList] = useState([]);

  // Get user info from token
  const getUserInfo = useCallback(() => {
    try {
      const token = localStorage.getItem('jwt') || localStorage.getItem('token') || localStorage.getItem('accessToken');
      if (token) {
        const decoded = jwtDecode(token);
        return decoded.id || decoded;
      }
    } catch (error) {
      console.error('Error decoding token:', error);
    }
    return null;
  }, []);

  const autoResizeDescription = useCallback(() => {
    const textarea = descriptionRef.current;
    if (textarea) {
      textarea.style.height = 'auto';
      textarea.style.height = `${textarea.scrollHeight}px`;
    }
  }, []);

  const validateEmail = useCallback((email) => {
    if (!email || email.trim() === '') {
      return '';
    }

    if (email.length > 55) {
      return 'Email must not exceed 55 characters';
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      return 'Please enter a valid email address';
    }

    return '';
  }, []);

  const validateCIN = useCallback((cin) => {
    if (!cin || cin.trim() === '') {
      return ''; // CIN is optional
    }


    return '';
  }, []);

  // Helper function to format date as DD/MM/YYYY
  const formatDateDDMMYYYY = useCallback((date = new Date()) => {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }, []);

  // Memoized API configuration - must be defined before handleChange
  const getConfig = useCallback(() => {
    const token = localStorage.getItem('token') || localStorage.getItem('jwt') || localStorage.getItem('accessToken');
    return {
      headers: {
        'Content-Type': 'application/json',
        ...(token && { 'Authorization': `Bearer ${token}` })
      }
    };
  }, []);

  const handleChange = useCallback((e) => {
    const { name, value } = e.target;

    if (name === "dslNo") {
      // For FACTO role, DSL No is disabled, so don't allow changes
      const userInfo = getUserInfo();
      if (userInfo && userInfo.ROLE_CODE === 'FACTO') {
        // Field is disabled, so onChange shouldn't trigger, but just in case
        return;
      }

      // Allow empty string and numeric input for DSL No
      if (value === "" || isNumeric(value)) {
        // If DSL is cleared, reset all fields
        if (value === "") {
          console.log('DSL cleared, resetting all fields');
          setFormData({
            year: '',
            scheduleDespatchNo: '',
            pslNo: '',
            schemeCode: '',
            industryCodeFrame: '',
            industryCodeReturn: '',
            descriptionOfIndustry: '',
            state: '',
            stateCode: '',
            district: '',
            sector: '',
            roSroCode: '',
            numberOfUnits: '',
            statusOfUnit: '',
            nameUnit: '',
            addressUnit: '',
            villTown: '',
            districtName: '',
            stateName: '',
            pinCode: '',
            emailId: '',
            mobileNumber: '',
            typeOfOrg: '',
            hasCIN: '',
            cin: '',
            isoCert: '',
            yearOfInitialProd: '',
            accountingYearFrom: '',
            accountingYearTo: '',
            monthsOfOperation: '',
            shareCapital: '',
            rdUnit: '',
            rdMaleEmployees: '',
            rdFemaleEmployees: '',
            rdTransgenderEmployees: '',
            contactName: '',
            contactTele: '',
            contactFax: '',
            contactEmail: '',
            contactPersonName: '',
            contactPersonDesignation: '',
            contactPersonEmail: '',
            contactPersonMobile: '',
            formalTraining: '',
            trainingMaleEmployees: '',
            trainingFemaleEmployees: '',
            trainingTransgenderEmployees: '',
            gstin: '',
            dslNo: '',
          });

          // Reset date pickers
          setStartDate(null);
          setEndDate(null);

          // Reset file upload
          setUploadedFile(null);
          setUploadScheduleFile(null);
          setFormData(prev => ({ ...prev, uploadScheduleFileName: '' }));

          // Reset all states
          setIsDataLoaded(false);
          setIsApiLoading(false);
          setIsFirstLoad(false);
          lastApiCallRef.current = { dslNo: '', year: '' };
          setErrors({ contactEmail: '', cin: '' });

          // Clear saved pages and reset header colors (green to grey)
          clearSavedPages();
          window.dispatchEvent(new CustomEvent('refreshBalanceSheetHeader'));

          console.log('✅ Reset completed - isFirstLoad set to false, ready for new API calls');
        } else {
          console.log('📝 DSL No. updated to:', value);
          setFormData(prev => ({ ...prev, [name]: value }));
          setIsDataLoaded(false);
          lastApiCallRef.current = { dslNo: '', year: '' };
          setErrors({ contactEmail: '', cin: '' });

          console.log('🔄 States reset - ready for API call when year is selected');
        }
      }
      return;
    }

    // Validate numeric fields for R&D and Training employees (max 6 digits)
    const numericEmployeeFields = ['rdMaleEmployees', 'rdFemaleEmployees', 'rdTransgenderEmployees',
      'trainingMaleEmployees', 'trainingFemaleEmployees', 'trainingTransgenderEmployees'];
    if (numericEmployeeFields.includes(name)) {
      if (value && !/^\d*$/.test(value)) {
        toast.error('Please enter numeric value only.', messages.COLOR_RED);
        return;
      }
      // Limit to 6 digits
      if (value.length > 6) {
        const sanitizedValue = value.substring(0, 6);
        setFormData(prev => ({ ...prev, [name]: sanitizedValue }));
        return;
      }
    }

    // Validate months of operation (max 2 digits, numeric only)
    if (name === 'monthsOfOperation') {
      if (value && !/^\d*$/.test(value)) {
        toast.error('Please enter numeric value only.', messages.COLOR_RED);
        return;
      }
      if (value.length > 2) {
        const sanitizedValue = value.substring(0, 2);
        setFormData(prev => ({ ...prev, [name]: sanitizedValue }));
        return;
      }
    }

    // Validate PIN code (6 digits, numeric only)
    if (name === "pinCode") {
      if (value && !/^\d*$/.test(value)) {
        toast.error('PIN Code should be numeric only.', messages.COLOR_RED);
        return;
      }
      if (value.length > 6) {
        const sanitizedValue = value.substring(0, 6);
        setFormData(prev => ({ ...prev, [name]: sanitizedValue }));
        return;
      }
    }

    // Validate mobile numbers (10 digits, numeric only)
    const mobileFields = ['contactPersonMobile', 'mobileNumber'];
    if (mobileFields.includes(name)) {
      if (value && !/^\d*$/.test(value)) {
        toast.error('Mobile number should be numeric only.', messages.COLOR_RED);
        return;
      }
      if (value.length > 10) {
        const sanitizedValue = value.substring(0, 10);
        setFormData(prev => ({ ...prev, [name]: sanitizedValue }));
        return;
      }
    }

    // Validate state code (max 5 digits, numeric only)
    if (name === 'stateCode') {
      if (value && !/^\d*$/.test(value)) {
        toast.error('State Code should be numeric only.', messages.COLOR_RED);
        return;
      }
      if (value.length > 5) {
        const sanitizedValue = value.substring(0, 5);
        setFormData(prev => ({ ...prev, [name]: sanitizedValue }));
        return;
      }
    }

    // Validate Year of initial production (numeric only, max 4 digits for year)
    if (name === 'yearOfInitialProd') {
      if (value && !/^\d*$/.test(value)) {
        toast.error('Entry only number', messages.COLOR_RED);
        return;
      }
      if (value.length > 4) {
        const sanitizedValue = value.substring(0, 4);
        setFormData(prev => ({ ...prev, [name]: sanitizedValue }));
        return;
      }
    }

    // Validate Accounting Year fields (MM/YY format)
    if (name === 'accountingYearFrom' || name === 'accountingYearTo') {
      // Allow only numbers and forward slash
      if (value && !/^[0-9/]*$/.test(value)) {
        toast.error('Enter number value only', messages.COLOR_RED);
        return;
      }

      // Remove any existing slashes to process
      let digitsOnly = value.replace(/\//g, '');

      // Auto-format: if 2 or more digits, add / after 2nd digit
      let formattedValue = '';
      if (digitsOnly.length <= 2) {
        formattedValue = digitsOnly;
      } else if (digitsOnly.length <= 4) {
        // Format as MM/YY
        formattedValue = digitsOnly.substring(0, 2) + '/' + digitsOnly.substring(2, 4);
      } else {
        // Limit to 4 digits total (MM/YY = 5 chars including /)
        formattedValue = digitsOnly.substring(0, 2) + '/' + digitsOnly.substring(2, 4);
      }

      // Limit to 5 characters (MM/YY format)
      if (formattedValue.length > 5) {
        formattedValue = formattedValue.substring(0, 5);
      }

      setFormData(prev => ({ ...prev, [name]: formattedValue }));
      return;
    }

    // Validate industry code return (5 digits, numeric only)
    if (name === 'industryCodeReturn') {
      if (value && !/^\d*$/.test(value)) {
        toast.error('Industry Code Per Return should be numeric only.', messages.COLOR_RED);
        return;
      }
      if (value.length > 5) {
        const sanitizedValue = value.substring(0, 5);
        setFormData(prev => ({ ...prev, [name]: sanitizedValue }));
        return;
      }

      // Call API to fetch description when industry code is selected (5 digits)
      const codeValue = value ? String(value).trim() : '';
      if (codeValue && codeValue.length === 5) {
        // Use setTimeout to ensure formData is updated first and fetchNicIndustryDescription is available
        setTimeout(() => {
          // Call API to fetch description
          const fetchDescription = async () => {
            try {
              showLoading(true);
              const response = await axios.get(
                `${API_URL}api/asi/nicIndustryMaster?niccode=${codeValue}`,
                getConfig()
              );

              if (response.data && response.data.status && response.data.data && response.data.data.length > 0) {
                const nicDescription = response.data.data[0].nicDescription || '';
                setFormData(prev => ({
                  ...prev,
                  descriptionOfIndustry: nicDescription
                }));
              } else {
                if (response.data && response.data.status === false && response.data.message) {
                  toast.error(response.data.message, messages.COLOR_RED);
                }
                setFormData(prev => ({
                  ...prev,
                  descriptionOfIndustry: ''
                }));
              }
            } catch (error) {
              console.error('Error fetching NIC Industry Description:', error);
              setFormData(prev => ({
                ...prev,
                descriptionOfIndustry: ''
              }));
              toast.error('NIC Industry code not found', messages.COLOR_RED);
            } finally {
              showLoading(false);
            }
          };
          fetchDescription();
        }, 100);
      } else if (codeValue === '') {
        // If field is cleared, also clear description
        setFormData(prev => ({ ...prev, descriptionOfIndustry: '' }));
      }
    }

    // Validate text fields (villageTown, districtName, stateName, contactPersonName, contactPersonDesignation) - letters, spaces, dots, hyphens only, max 100 chars
    const textFields = ['villTown', 'districtName', 'stateName', 'contactPersonName', 'contactPersonDesignation', 'nameUnit'];
    if (textFields.includes(name)) {
      const textOnlyValue = value.replace(/[^a-zA-Z\s\.\-\'\(\)]/g, '');
      if (value !== textOnlyValue) {
        toast.error(`${name === 'contactPersonName' ? 'Name' : name === 'contactPersonDesignation' ? 'Designation' : 'Field'} should contain only letters, spaces, dots, and hyphens.`, messages.COLOR_RED);
        return;
      }
      if (value.length > 100) {
        const sanitizedValue = value.substring(0, 100);
        setFormData(prev => ({ ...prev, [name]: sanitizedValue }));
        return;
      }
    }

    // Validate email fields (max 100 chars for 2024-2025, 55 for older years)
    const emailFields = ['emailId', 'contactPersonEmail'];
    if (emailFields.includes(name)) {
      const is2024Year = !formData.year || formData.year.startsWith('2024');
      const maxLength = is2024Year ? 100 : 55;
      if (value && value.length > maxLength) {
        const sanitizedValue = value.substring(0, maxLength);
        setFormData(prev => ({ ...prev, [name]: sanitizedValue }));
        return;
      }
      // Email format validation will be done on blur or submit
    }

    // Validate GSTIN (15 characters, alphanumeric)
    if (name === 'gstin') {
      const alphanumericValue = value.replace(/[^a-zA-Z0-9]/g, '');
      if (value !== alphanumericValue) {
        toast.error('GSTIN should contain only alphanumeric characters.', messages.COLOR_RED);
        return;
      }
      if (value.length > 15) {
        const sanitizedValue = value.substring(0, 15);
        setFormData(prev => ({ ...prev, [name]: sanitizedValue }));
        return;
      }
    }

    // Validate CIN (21 characters for 2024-2025, 25 for older years, alphanumeric)
    if (name === 'cin') {
      const is2024Year = !formData.year || formData.year.startsWith('2024');
      const maxLength = is2024Year ? 21 : 25;
      const alphanumericValue = value.replace(/[^a-zA-Z0-9]/g, '');
      if (value !== alphanumericValue) {
        toast.error('CIN should contain only alphanumeric characters.', messages.COLOR_RED);
        return;
      }
      if (value.length > maxLength) {
        const sanitizedValue = value.substring(0, maxLength);
        setFormData(prev => ({ ...prev, [name]: sanitizedValue }));
        return;
      }
    }

    // Validate description of industry (max 200 chars for 2024-2025, 500 for older years)
    if (name === 'descriptionOfIndustry') {
      const is2024Year = !formData.year || formData.year.startsWith('2024');
      const maxLength = is2024Year ? 200 : 500;
      if (value.length > maxLength) {
        const sanitizedValue = value.substring(0, maxLength);
        setFormData(prev => ({ ...prev, [name]: sanitizedValue }));
        return;
      }
    }

    if (name === "contactEmail") {
      // Validate email format
      const emailError = validateEmail(value);
      setErrors(prev => ({ ...prev, contactEmail: emailError }));
      setFormData(prev => ({ ...prev, [name]: value }));
      return;
    }

    if (name === "contactName") {
      // Validate name and designation - only letters, spaces, dots, and hyphens
      const textOnlyValue = value.replace(/[^a-zA-Z\s\.\-]/g, '');

      if (value !== textOnlyValue) {
        toast.error('Name and Designation should contain only letters, spaces, dots, and hyphens', messages.COLOR_RED);
        return;
      }

      // Limit to 100 characters
      if (textOnlyValue.length > 100) {
        toast.error('Name and Designation should not exceed 100 characters', messages.COLOR_RED);
        return;
      }

      setFormData(prev => ({ ...prev, [name]: textOnlyValue }));
      return;
    }

    // CIN validation is already handled above in the CIN section

    setFormData(prev => ({ ...prev, [name]: value }));

    if (name === 'descriptionOfIndustry') {
      requestAnimationFrame(() => autoResizeDescription());
    }

    // Reset data loaded flag when year changes
    if (name === "year") {
      // Validate DSL No for FACTO role before allowing year selection
      const userInfo = getUserInfo();
      if (userInfo && userInfo.ROLE_CODE === 'FACTO' && userInfo.USER_ID) {
        const expectedDSL = String(userInfo.USER_ID).trim();
        const currentDSL = String(formData.dslNo).trim();

        // If DSL doesn't match USER_ID, show error and prevent year selection
        if (currentDSL && currentDSL !== expectedDSL) {
          toast.error('Invalid DSL No.', messages.COLOR_RED);
          // Reset DSL No to USER_ID and clear year
          setFormData(prev => ({ ...prev, dslNo: expectedDSL, year: '' }));
          return;
        }
      }

      setIsDataLoaded(false);
      // Clear API call reference for new year
      lastApiCallRef.current = { dslNo: '', year: '' };
      // Clear validation toast refs when year changes
      Object.keys(toastShownRef.current).forEach(key => {
        if (key.startsWith('validateDSL') || key.startsWith('validateDateRange')) {
          delete toastShownRef.current[key];
        }
      });
    }

    // Clear validation toast refs when DSL No changes
    if (name === "dslNo") {
      Object.keys(toastShownRef.current).forEach(key => {
        if (key.startsWith('validateDSL')) {
          delete toastShownRef.current[key];
        }
      });
    }
  }, [autoResizeDescription, validateEmail, getConfig, getUserInfo]);


  const handleStartDateChange = useCallback((date) => {
    setStartDate(date);
    // Clear date validation toast refs when date changes
    Object.keys(toastShownRef.current).forEach(key => {
      if (key.startsWith('validateDateRange')) {
        delete toastShownRef.current[key];
      }
    });
    if (endDate && date && endDate < date) {
      setEndDate(null);
      const toastKey = 'date-start-end-warning';
      if (!toastShownRef.current[toastKey]) {
        toast.warning('End date cannot be before start date', messages.COLOR_RED);
        toastShownRef.current[toastKey] = true;
        setTimeout(() => delete toastShownRef.current[toastKey], 3000);
      }
    }
  }, [endDate]);

  const handleEndDateChange = useCallback((date) => {
    // Clear date validation toast refs when date changes
    Object.keys(toastShownRef.current).forEach(key => {
      if (key.startsWith('validateDateRange')) {
        delete toastShownRef.current[key];
      }
    });
    if (startDate && date && date < startDate) {
      const toastKey = 'date-end-before-start';
      if (!toastShownRef.current[toastKey]) {
        toast.error('End date cannot be before start date', messages.COLOR_RED);
        toastShownRef.current[toastKey] = true;
        setTimeout(() => delete toastShownRef.current[toastKey], 3000);
      }
      return;
    }
    setEndDate(date);
  }, [startDate]);

  const validateDSLMandatory = useCallback(() => {
    const toastKey = 'validateDSL';

    if (!formData.dslNo || formData.dslNo.trim() === '') {
      if (!toastShownRef.current[`${toastKey}-dsl-mandatory`]) {
        toast.error('DSL No. is mandatory', messages.COLOR_RED);
        toastShownRef.current[`${toastKey}-dsl-mandatory`] = true;
        setTimeout(() => delete toastShownRef.current[`${toastKey}-dsl-mandatory`], 3000);
      }
      return false;
    }

    if (formData.dslNo.length !== 6) {
      if (!toastShownRef.current[`${toastKey}-dsl-length`]) {
        toast.error('DSL No. should be 6 digits', messages.COLOR_RED);
        toastShownRef.current[`${toastKey}-dsl-length`] = true;
        setTimeout(() => delete toastShownRef.current[`${toastKey}-dsl-length`], 3000);
      }
      return false;
    }

    if (!/^\d{6}$/.test(formData.dslNo)) {
      if (!toastShownRef.current[`${toastKey}-dsl-numeric`]) {
        toast.error('DSL No. should contain only numbers', messages.COLOR_RED);
        toastShownRef.current[`${toastKey}-dsl-numeric`] = true;
        setTimeout(() => delete toastShownRef.current[`${toastKey}-dsl-numeric`], 3000);
      }
      return false;
    }

    // Check if Year is selected
    if (!formData.year || formData.year.trim() === '') {
      if (!toastShownRef.current[`${toastKey}-year-mandatory`]) {
        toast.error('Year is mandatory', messages.COLOR_RED);
        toastShownRef.current[`${toastKey}-year-mandatory`] = true;
        setTimeout(() => delete toastShownRef.current[`${toastKey}-year-mandatory`], 3000);
      }
      return false;
    }

    return true;
  }, [formData.dslNo, formData.year]);

  // Function to validate date range
  const validateDateRange = useCallback(() => {
    const toastKey = 'validateDateRange';

    // Make dates optional - only validate if both dates are provided
    if (!startDate && !endDate) {
      return true; // Both dates are empty, skip validation
    }

    // If only one date is provided, show error
    if ((startDate && !endDate) || (!startDate && endDate)) {
      if (!toastShownRef.current[`${toastKey}-both-dates`]) {
        toast.error('Please select both start and end dates or leave both empty', messages.COLOR_RED);
        toastShownRef.current[`${toastKey}-both-dates`] = true;
        setTimeout(() => delete toastShownRef.current[`${toastKey}-both-dates`], 3000);
      }
      return false;
    }

    // If both dates are provided, validate range
    if (startDate && endDate && endDate < startDate) {
      if (!toastShownRef.current[`${toastKey}-end-before-start`]) {
        toast.error('End date cannot be before start date', messages.COLOR_RED);
        toastShownRef.current[`${toastKey}-end-before-start`] = true;
        setTimeout(() => delete toastShownRef.current[`${toastKey}-end-before-start`], 3000);
      }
      return false;
    }

    return true;
  }, [startDate, endDate]);

  // Function to reset form data
  const handleReset = useCallback(() => {
    console.log('🔄 Reset button clicked - clearing all data');

    setFormData({
      year: '',
      scheduleDespatchNo: '',
      pslNo: '',
      schemeCode: '',
      industryCodeFrame: '',
      industryCodeReturn: '',
      descriptionOfIndustry: '',
      state: '',
      stateCode: '',
      district: '',
      sector: '',
      roSroCode: '',
      numberOfUnits: '',
      statusOfUnit: '',
      nameUnit: '',
      addressUnit: '',
      villTown: '',
      districtName: '',
      stateName: '',
      pinCode: '',
      emailId: '',
      mobileNumber: '',
      typeOfOrg: '',
      hasCIN: '',
      cin: '',
      isoCert: '',
      yearOfInitialProd: '',
      accountingYearFrom: '',
      accountingYearTo: '',
      monthsOfOperation: '',
      shareCapital: '',
      rdUnit: '',
      rdMaleEmployees: '',
      rdFemaleEmployees: '',
      rdTransgenderEmployees: '',
      contactName: '',
      contactTele: '',
      contactFax: '',
      contactEmail: '',
      contactPersonName: '',
      contactPersonDesignation: '',
      contactPersonEmail: '',
      contactPersonMobile: '',
      formalTraining: '',
      trainingMaleEmployees: '',
      trainingFemaleEmployees: '',
      trainingTransgenderEmployees: '',
      gstin: '',
      dslNo: '', // Added DSL No. field to state
      verificationCompilationDate: '',
      entryMode: 'balanceSheet',
      documentPath: '', // Added for Upload/Download Supported Documents
      documentPathFull: '', // Added for full file path from API (for download)
      uploadScheduleFileName: '', // Added for Upload Schedule file name display
      uploadScheduleFilePath: '', // Added for Upload Schedule file path from API (for download)
      remarksBlock: '', // Added for Remarks section
      remarksItems: '', // Added for Remarks section
      remarks: '', // Added for Remarks section
      remarksCreatedOn: '', // Added for Remarks Created On
      remarksBy: '', // Added for Remarks By
      remarksRole: '', // Added for Remarks Role
    });

    // Reset date pickers
    setStartDate(null);
    setEndDate(null);
    setVerificationDate(null);

    // Reset file upload
    setUploadedFile(null);
    setUploadScheduleFile(null);
    setFormData(prev => ({ ...prev, uploadScheduleFileName: '' }));

    // Reset loading states
    setIsDataLoaded(false);
    setIsApiLoading(false);
    setIsFirstLoad(false);

    // Clear API call reference
    lastApiCallRef.current = { dslNo: '', year: '' };

    // Reset remarks list
    setRemarksList([]);

    // Clear localStorage
    try {
      localStorage.removeItem('balanceSheetFormData');
      // Clear saved pages and access page IDs to reset header colors
      clearSavedPages();
      // Trigger custom event to refresh header
      window.dispatchEvent(new CustomEvent('refreshBalanceSheetHeader'));
    } catch (error) {
      console.error('Error clearing form data from localStorage:', error);
    }

    console.log('✅ Reset completed - ready for new API calls');
  }, []);

  // Function to fetch NIC Industry Description
  const fetchNicIndustryDescription = useCallback(async (nicCode) => {
    if (!nicCode || nicCode.length !== 5) {
      return;
    }

    try {
      showLoading(true);
      const response = await axios.get(
        `${API_URL}api/asi/nicIndustryMaster?niccode=${nicCode}`,
        getConfig()
      );

      if (response.data && response.data.status && response.data.data && response.data.data.length > 0) {
        const nicDescription = response.data.data[0].nicDescription || '';
        // Update description of industry field
        setFormData(prev => ({
          ...prev,
          descriptionOfIndustry: nicDescription
        }));
      } else {
        // If status is false, show error message from response
        if (response.data && response.data.status === false && response.data.message) {
          toast.error(response.data.message, messages.COLOR_RED);
        }
        // If no data found, clear description
        setFormData(prev => ({
          ...prev,
          descriptionOfIndustry: ''
        }));
      }
    } catch (error) {
      console.error('Error fetching NIC Industry Description:', error);
      setFormData(prev => ({
        ...prev,
        descriptionOfIndustry: ''
      }));
      toast.error('NIC Industry code not found', messages.COLOR_RED);
    } finally {
      showLoading(false);
    }
  }, [getConfig]);

  // Function to fetch data from API (optimized)
  const fetchIdentificationData = useCallback(async (dslNo, surveyYear, skipLoading = false) => {
    if (!dslNo || !surveyYear) return false;

    // Validate DSL No for FACTO role before API call
    const userInfo = getUserInfo();
    if (userInfo && userInfo.ROLE_CODE === 'FACTO' && userInfo.USER_ID) {
      const expectedDSL = String(userInfo.USER_ID).trim();
      const enteredDSL = String(dslNo).trim();

      // If DSL doesn't match USER_ID, show error and prevent API call
      if (enteredDSL !== expectedDSL) {
        toast.error('Invalid DSL No.', messages.COLOR_RED);
        // Reset DSL No to USER_ID
        setFormData(prev => ({ ...prev, dslNo: expectedDSL }));
        return false;
      }
    }

    // Prevent multiple API calls
    if (isApiLoading) {
      console.log('API call already in progress, skipping...');
      return false;
    }

    // Check if we already called API for this exact DSL and Year
    if (lastApiCallRef.current.dslNo === dslNo && lastApiCallRef.current.year === surveyYear) {
      console.log('API already called for this DSL and Year combination, skipping...');
      return true;
    }

    // Check if data is already loaded for this DSL and Year
    if (isDataLoaded && formData.dslNo === dslNo && formData.year === surveyYear) {
      console.log('Data already loaded for this DSL and Year');
      return true;
    }

    setIsApiLoading(true);
    if (!skipLoading) showLoading(true);

    try {
      const postData = {
        dsl_no: dslNo,
        survey_year: surveyYear.split('-')[0]
      };

      console.log('Making API call for DSL:', dslNo, 'Year:', surveyYear);

      // Update the last API call reference
      lastApiCallRef.current = { dslNo, year: surveyYear };

      // const response = await axios.post(`${API_URL}api/balance-sheet-asi-frame`, postData, getConfig());

      const response = await axios.post(`${API_URL}api/identification-particulars/get-data`, postData, getConfig());

      console.log('API Response:', response.data);

      const { data, status, message, remarks: remarksArray } = response.data;

      console.log('Extracted - Status:', status, 'Message:', message, 'Data:', data, 'Remarks:', remarksArray);

      // Handle case when status is false or no data found
      if (status === false || !data || (Array.isArray(data) && data.length === 0)) {
        const errorMessage = message || 'No data found for the specified DSL and survey year';
        console.log('⚠️ No data case - Showing message:', errorMessage);
        toast.warning(errorMessage, messages.COLOR_RED);
        setIsApiLoading(false);
        if (!skipLoading) showLoading(false);
        return false;
      }

      if (data && status && data.length > 0) {
        const apiData = data[0];

        console.log('API Data received:', apiData);

        // Convert sectorCode to dropdown value (1 for Rural, 2 for Urban)
        // API returns "1" or "2" directly, but we need to handle both formats
        let sectorValue = '';
        if (apiData.sectorCode) {
          sectorValue = apiData.sectorCode.toString();
        } else if (apiData.sector === 'Rural' || apiData.sector === '1' || apiData.sector === 1) {
          sectorValue = '1';
        } else if (apiData.sector === 'Urban' || apiData.sector === '2' || apiData.sector === 2) {
          sectorValue = '2';
        }

        // Convert isoCertification14000 to dropdown value (Yes/No → 1/2)
        let isoCertValue = '';
        if (apiData.isoCertification14000 === 'Yes' || apiData.isoCertification14000 === '1' || apiData.isoCert === '1') {
          isoCertValue = '1'; // Yes
        } else if (apiData.isoCertification14000 === 'No' || apiData.isoCertification14000 === '2' || apiData.isoCert === '2') {
          isoCertValue = '2'; // No
        }

        // Convert formalTraining to dropdown value (Yes/No → 1/2)
        let formalTrainingValue = '';
        if (apiData.formalTraining === 'Yes' || apiData.formalTraining === '1') {
          formalTrainingValue = '1';
        } else if (apiData.formalTraining === 'No' || apiData.formalTraining === '2') {
          formalTrainingValue = '2';
        }

        // Format surveyYear to "YYYY-YY" format if it's just a number
        let formattedYear = surveyYear;
        if (apiData.surveyYear) {
          const year = parseInt(apiData.surveyYear);
          if (!isNaN(year)) {
            formattedYear = `${year}-${(year + 1).toString().slice(-2)}`;
          }
        }

        // Map API response to form fields (preserve user's selected year and dslNo)
        const updatedFormData = {
          ...formData,
          dslNo: apiData.dslNo?.toString() || dslNo,
          year: formattedYear || surveyYear,
          scheduleDespatchNo: apiData.scheduleDespatchNo?.toString() || apiData.dslNo?.toString() || '',
          pslNo: apiData.pslNo?.toString() || '',
          schemeCode: apiData.schemeCode?.toString() || '',
          industryCodeFrame: apiData.nicCodePerFrame?.toString() || apiData.industryCodeFrame?.toString() || '',
          industryCodeReturn: apiData.industryCodeReturn?.toString() || '',
          descriptionOfIndustry: apiData.descriptionOfIndustry?.toString() || '',
          sector: sectorValue || '',
          roSroCode: apiData.roSroCode?.toString() || '',
          numberOfUnits: apiData.numberOfUnits?.toString() || '',
          statusOfUnit: apiData.statusOfUnitCode?.toString() || apiData.statusOfUnit?.toString() || '',
          typeOfOrg: apiData.typeOrganizationCode?.toString() || apiData.typeOfOrg?.toString() || '',
          yearOfInitialProd: apiData.yearInitialProduction?.toString() || apiData.yearOfInitialProd?.toString() || '',
          monthsOfOperation: apiData.numberOfMonthsOperation?.toString() || apiData.monthsOfOperation?.toString() || '',
          isoCert: isoCertValue || '',
          nameUnit: apiData.Name_Unit?.toString() || apiData.nameUnit?.toString() || apiData.addressUnit?.toString() || '',
          addressUnit: apiData.Address_Unit?.toString() || apiData.addressUnit?.toString() || '',
          villTown: apiData.Place_Unit?.toString() || apiData.villTown?.toString() || apiData.placeUnit?.toString() || '',
          district: apiData.districtCode?.toString() || apiData.district?.toString() || '',
          districtName: apiData.District_Name?.toString() || apiData.districtName?.toString() || '',
          state: apiData.state?.toString() || apiData.stateCode?.toString() || '',
          stateCode: apiData.stateCode?.toString() || '',
          stateName: apiData.State_Name?.toString() || apiData.stateName?.toString() || '',
          pinCode: apiData.pinCode?.toString() || apiData.pin?.toString() || '',
          emailId: apiData.emailId?.toString() || apiData.email?.toString() || '',
          mobileNumber: apiData.mobileNumber?.toString() || apiData.mobile?.toString() || '',
          hasCIN: apiData.hasCIN?.toString() || '',
          cin: apiData.corporateIdentificationNumber?.toString() || apiData.cin?.toString() || '',
          contactName: apiData.contactName?.toString() || '',
          contactTele: apiData.contactTele?.toString() || apiData.tele?.toString() || '',
          contactFax: apiData.contactFax?.toString() || apiData.fax?.toString() || '',
          contactEmail: apiData.contactEmail?.toString() || '',
          contactPersonName: apiData.contactPersonName?.toString() || '',
          contactPersonDesignation: apiData.contactPersonDesignation?.toString() || '',
          contactPersonEmail: apiData.contactPersonEmail?.toString() || '',
          contactPersonMobile: apiData.contactPersonMobile?.toString() || '',
          formalTraining: formalTrainingValue || '',
          shareCapital: apiData.shareCapital?.toString() || '',
          rdUnit: apiData.rdUnit?.toString() || '',
          rdMaleEmployees: apiData.rdMaleEmployees?.toString() || '',
          rdFemaleEmployees: apiData.rdFemaleEmployees?.toString() || '',
          rdTransgenderEmployees: apiData.rdTransgenderEmployees?.toString() || '',
          trainingMaleEmployees: apiData.trainingMaleEmployees?.toString() || '',
          trainingFemaleEmployees: apiData.trainingFemaleEmployees?.toString() || '',
          trainingTransgenderEmployees: apiData.trainingTransgenderEmployees?.toString() || '',
          gstin: apiData.gstin?.toString() || '',
          verificationCompilationDate: (apiData.Compilation_Date?.toString() || apiData.verificationCompilationDate?.toString() || apiData.compilationDate?.toString()) || formatDateDDMMYYYY(),
          documentPath: (() => {
            // Extract filename from path if uploadedFile contains path
            const filePath = apiData.uploadedFile?.toString() || apiData.documentPath?.toString() || '';
            if (filePath) {
              // Extract filename from path (e.g., "uploads/uploadedFile-1767074196395-269347727.xls" -> "uploadedFile-1767074196395-269347727.xls")
              const fileName = filePath.split('/').pop() || filePath;
              return fileName;
            }
            return '';
          })(),
          documentPathFull: apiData.uploadedFile?.toString() || apiData.documentPath?.toString() || '', // Store full path for download
          accountingYearFrom: apiData.accountingYearStart?.toString() || apiData.accountingYearFrom?.toString() || '',
          accountingYearTo: apiData.accountingYearEnd?.toString() || apiData.accountingYearTo?.toString() || '',
          // Don't map remarks input fields from API - set Block to "ALL" by default to show all remarks in list
          remarksBlock: 'ALL',
          remarksItems: '',
          remarks: ''
        };

        console.log('Updated form data:', updatedFormData);

        // Batch state updates for better performance
        setFormData(updatedFormData);
        requestAnimationFrame(() => autoResizeDescription());
        setIsDataLoaded(true);

        // Map remarks data for Remarks List from the separate remarks array in API response
        if (remarksArray && Array.isArray(remarksArray) && remarksArray.length > 0) {
          const mappedRemarksList = remarksArray.map((remark, index) => ({
            slNo: index + 1,
            blocks: remark.block?.toString() || '',
            columns: remark.columnsName?.toString() || '-',
            items: remark.items?.toString() || '',
            remarks: remark.remarks?.toString() || '',
            createdTime: remark.createdDate || remark.createdTime || '',
            updatedBy: remark.updatedBy?.toString() || remark.createdBy?.toString() || '',
            role: remark.updatedBy?.toString() || remark.createdBy?.toString() || ''
          }));
          setRemarksList(mappedRemarksList);
          console.log('Mapped Remarks List:', mappedRemarksList);
        } else {
          setRemarksList([]);
        }

        // Set accounting year dates if available (format: "2022-23")
        if (apiData.accountingYear) {
          const yearParts = apiData.accountingYear.split('-');
          if (yearParts.length === 2) {
            const startYear = parseInt(yearParts[0]);
            if (!isNaN(startYear)) {
              setStartDate(new Date(startYear, 3, 1));
              setEndDate(new Date(startYear + 1, 2, 31));
            }
          }
        }

        // Save to localStorage immediately after API fetch
        try {
          const dataToSave = {
            ...updatedFormData,
            accountingYearFrom: startDate ? startDate.toISOString() : null,
            accountingYearTo: endDate ? endDate.toISOString() : null
          };
          localStorage.setItem('balanceSheetFormData', JSON.stringify(dataToSave));
          // Set flag to enable all pages in progress bar after API success
          localStorage.setItem('balanceSheetDataLoaded', 'true');
          // Save loginTime to detect logout/login
          const currentLoginTime = localStorage.getItem('loginTime');
          if (currentLoginTime) {
            localStorage.setItem('balanceSheetLoginTime', currentLoginTime);
          }
        } catch (error) {
          console.error('Error saving to localStorage:', error);
        }

        // Refresh balance sheet validation to update header colors after fetching data
        if (dslNo && surveyYear) {
          await refreshBalanceSheetValidation(dslNo, surveyYear);
        }

        return true;
      }

    } catch (error) {
      console.error('API Error:', error);

      // Handle specific error responses
      if (error.response && error.response.data) {
        const { status, message } = error.response.data;

        // If API explicitly returns status: false with a message
        if (status === false && message) {
          toast.warning(message, messages.COLOR_RED);
        } else if (error.response.status === 404) {
          toast.warning('No data found for the specified DSL and survey year', messages.COLOR_RED);
        } else if (error.response.status === 401) {
          toast.error('Session expired. Please login again.', messages.COLOR_RED);
        } else if (error.response.status === 500) {
          toast.error('Server error. Please try again later.', messages.COLOR_RED);
        } else {
          const errorMsg = message || error.response.data.message || 'An error occurred while processing your request.';
          toast.error(errorMsg, messages.COLOR_RED);
        }
      } else {
        toast.error('An error occurred while processing your request.', messages.COLOR_RED);
      }
      return false;
    } finally {
      setIsApiLoading(false);
      if (!skipLoading) showLoading(false);
    }
  }, [autoResizeDescription, isApiLoading, isDataLoaded, formData.dslNo, formData.year, getConfig, startDate, endDate, formatDateDDMMYYYY, getUserInfo]);

  const storedLanguage = localStorage.getItem('language');

  // Listen for logout (token removal) and clear DSL No and Year
  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === 'jwt' || e.key === 'token' || e.key === 'accessToken') {
        // Token was removed (logout)
        if (!e.newValue || e.newValue === 'null' || e.newValue.trim() === '') {
          console.log('🔄 Logout detected - clearing DSL No and Year');
          setFormData(prev => ({ ...prev, dslNo: '', year: '' }));
          localStorage.removeItem('balanceSheetFormData');
          clearSavedPages();
        }
      }
    };

    window.addEventListener('storage', handleStorageChange);

    // Also check on mount if token exists
    const token = localStorage.getItem('jwt') || localStorage.getItem('token') || localStorage.getItem('accessToken');
    if (!token || token === 'null' || token.trim() === '') {
      console.log('🔄 No token found - clearing DSL No and Year');
      setFormData(prev => ({ ...prev, dslNo: '', year: '' }));
      localStorage.removeItem('balanceSheetFormData');
      clearSavedPages();
    }

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  // Fetch Industry Code Return data on component mount
  useEffect(() => {
    const fetchIndustryCodeReturn = async () => {
      try {
        showLoading(true);
        const response = await axios.get(`${API_URL}api/input-items-indigenous/IndustrycodeasperReturnData`, getConfig());

        if (response.data && response.data.status && response.data.data) {
          setIndustryCodeReturnList(response.data.data);
        } else {
          console.error('Failed to fetch industry codes:', response.data?.message);
        }
      } catch (error) {
        console.error('Error fetching industry codes:', error);
        toast.error('Failed to load industry codes', messages.COLOR_RED);
      } finally {
        showLoading(false);
      }
    };

    fetchIndustryCodeReturn();
  }, []);

  // Fetch Unit Codes for StatusUnitDropdown
  useEffect(() => {
    const fetchUnitCodes = async () => {
      try {
        const response = await axios.get(`${API_URL}api/asi/unitCodes`, getConfig());
        if (response.data && response.data.status) {
          setUnitCodes(response.data.data || []);
        }
      } catch (error) {
        console.error('Error fetching unit codes:', error);
        setUnitCodes([]);
      }
    };

    fetchUnitCodes();
  }, []);

  useEffect(() => {
    autoResizeDescription();
  }, [autoResizeDescription]);

  useEffect(() => {
    autoResizeDescription();
  }, [autoResizeDescription, formData.descriptionOfIndustry]);


  // Memoized API call logic - only call when user manually enters DSL and Year
  const shouldMakeApiCall = useMemo(() => {
    const result = !isFirstLoad && // Not first load
      formData.dslNo &&
      formData.dslNo.length === 6 &&
      formData.year &&
      !isDataLoaded &&
      !isApiLoading &&
      (lastApiCallRef.current.dslNo !== formData.dslNo || lastApiCallRef.current.year !== formData.year);

    console.log('🔍 shouldMakeApiCall Check:', {
      isFirstLoad,
      dslNo: formData.dslNo,
      dslLength: formData.dslNo?.length,
      year: formData.year,
      isDataLoaded,
      isApiLoading,
      lastApiCall: lastApiCallRef.current,
      result
    });

    return result;
  }, [isFirstLoad, formData.dslNo, formData.year, isDataLoaded, isApiLoading]);

  // Load saved data on component mount (with route-based logic)
  useEffect(() => {
    let isMounted = true;

    const loadDataWithRouteCheck = async () => {
      try {
        // Check if user is logged out (no jwt token)
        const token = localStorage.getItem('jwt') || localStorage.getItem('token') || localStorage.getItem('accessToken');
        if (!token || token === 'null' || token.trim() === '') {
          // User is logged out - clear DSL No and Year
          console.log('🔄 User logged out - clearing DSL No and Year');
          localStorage.removeItem('balanceSheetFormData');
          setFormData(prev => ({ ...prev, dslNo: '', year: '' }));
          setIsFirstLoad(false);
          setIsDataLoaded(true);
          return;
        }

        // Get user info for FACTO role auto-fill
        const userInfo = getUserInfo();
        const isFACTO = userInfo && userInfo.ROLE_CODE === 'FACTO';
        const userDSL = isFACTO && userInfo.USER_ID ? String(userInfo.USER_ID).trim() : '';

        // Check if this is a new login session (loginTime changed)
        const currentLoginTime = localStorage.getItem('loginTime');
        const savedLoginTime = localStorage.getItem('balanceSheetLoginTime');

        // If loginTime doesn't match, it means user logged out and logged in again
        if (currentLoginTime && savedLoginTime && currentLoginTime !== savedLoginTime) {
          console.log('🔄 New login session detected - clearing saved data');
          localStorage.removeItem('balanceSheetFormData');
          clearSavedPages();
          // For FACTO role, set USER_ID as DSL No
          if (isFACTO && userDSL) {
            setFormData(prev => ({
              ...prev,
              dslNo: userDSL,
              year: '',
              verificationCompilationDate: formatDateDDMMYYYY()
            }));
          } else {
            setFormData(prev => ({
              ...prev,
              dslNo: '',
              year: '',
              verificationCompilationDate: formatDateDDMMYYYY()
            }));
          }
          setIsFirstLoad(false);
          setIsDataLoaded(true);
          // Save current loginTime for next check
          localStorage.setItem('balanceSheetLoginTime', currentLoginTime);
          return;
        }

        // If no saved loginTime, save current one
        if (currentLoginTime && !savedLoginTime) {
          localStorage.setItem('balanceSheetLoginTime', currentLoginTime);
        }

        // Check if coming from asiScheduleMainMenu
        const fromMainMenuFlag = localStorage.getItem('fromAsiScheduleMainMenu');
        const isFromMainMenu = fromMainMenuFlag === 'true';

        console.log('Route Check - Flag:', fromMainMenuFlag, 'isFromMainMenu:', isFromMainMenu);

        // Clear the flag
        if (fromMainMenuFlag) {
          localStorage.removeItem('fromAsiScheduleMainMenu');
        }

        // For FACTO role, always use USER_ID and clear saved data if DSL doesn't match
        if (isFACTO && userDSL) {
          const savedData = localStorage.getItem('balanceSheetFormData');
          if (savedData) {
            try {
              const parsedData = JSON.parse(savedData);
              // If saved DSL doesn't match USER_ID, clear saved data
              if (parsedData.dslNo && String(parsedData.dslNo).trim() !== userDSL) {
                console.log('🔄 FACTO user - Saved DSL does not match USER_ID, clearing saved data');
                console.log('Saved DSL:', parsedData.dslNo, 'Expected USER_ID:', userDSL);
                localStorage.removeItem('balanceSheetFormData');
                clearSavedPages();
                // Set fresh data with USER_ID
                setFormData({
                  year: '', scheduleDespatchNo: '', pslNo: '', schemeCode: '',
                  industryCodeFrame: '', industryCodeReturn: '', descriptionOfIndustry: '',
                  state: '', district: '', sector: '', roSroCode: '', numberOfUnits: '',
                  statusOfUnit: '', nameUnit: '', addressUnit: '', villTown: '',
                  districtName: '', stateName: '', pinCode: '', typeOfOrg: '', cin: '',
                  isoCert: '', yearOfInitialProd: '', accountingYearFrom: '',
                  accountingYearTo: '', monthsOfOperation: '', shareCapital: '',
                  rdUnit: '', contactName: '', contactTele: '', contactFax: '',
                  contactEmail: '', formalTraining: '', dslNo: userDSL,
                  verificationCompilationDate: formatDateDDMMYYYY(),
                  entryMode: 'balanceSheet',
                  documentPath: '', documentPathFull: '', uploadScheduleFileName: '',
                  uploadScheduleFilePath: '', remarksBlock: '', remarksItems: '',
                  remarks: '', remarksCreatedOn: '', remarksBy: '', remarksRole: ''
                });
                setStartDate(null);
                setEndDate(null);
                setErrors({ contactEmail: '', cin: '' });
                setIsFirstLoad(false);
                setIsDataLoaded(true);
                return;
              }
            } catch (error) {
              console.error('Error parsing saved data:', error);
              localStorage.removeItem('balanceSheetFormData');
            }
          }
        }

        // Always check for saved data first, regardless of route
        const savedData = localStorage.getItem('balanceSheetFormData');

        if (savedData && isMounted) {
          const parsedData = JSON.parse(savedData);

          if (isFACTO && userDSL) {
            parsedData.dslNo = userDSL;
          }

          if (isFromMainMenu) {
            console.log('✅ Loading from Main Menu - Data will be loaded, API will be called');
            console.log('📦 Parsed Data:', parsedData);

            const dataWithDate = {
              ...parsedData,
              dslNo: isFACTO && userDSL ? userDSL : parsedData.dslNo,
              year: isFACTO && userDSL ? '' : parsedData.year,
              verificationCompilationDate: parsedData.verificationCompilationDate || formatDateDDMMYYYY()
            };
            setFormData(dataWithDate);

            if (currentLoginTime) {
              localStorage.setItem('balanceSheetLoginTime', currentLoginTime);
            }

            if (parsedData.accountingYearFrom && parsedData.accountingYearTo) {
              setStartDate(new Date(parsedData.accountingYearFrom));
              setEndDate(new Date(parsedData.accountingYearTo));
            }

            // Set flags
            setIsFirstLoad(false);
            setIsDataLoaded(false);
            lastApiCallRef.current = { dslNo: '', year: '' };

            // DIRECTLY CALL API HERE - use dataWithDate.dslNo (which has USER_ID for FACTO)
            if (dataWithDate.dslNo && dataWithDate.year) {
              console.log('🚀 Calling API directly for DSL:', dataWithDate.dslNo, 'Year:', dataWithDate.year);
              setTimeout(() => {
                fetchIdentificationData(dataWithDate.dslNo, dataWithDate.year);
              }, 100);
            }
          } else {

            console.log('✅ Loading from other route/refresh - Checking for DSL and Year');
            console.log('📦 Parsed Data:', parsedData);


            const dataWithDate = {
              ...parsedData,
              dslNo: isFACTO && userDSL ? userDSL : parsedData.dslNo,
              year: isFACTO && userDSL ? '' : parsedData.year,
              verificationCompilationDate: parsedData.verificationCompilationDate || formatDateDDMMYYYY()
            };
            setFormData(dataWithDate);

            // Save loginTime when loading saved data
            if (currentLoginTime) {
              localStorage.setItem('balanceSheetLoginTime', currentLoginTime);
            }

            if (parsedData.accountingYearFrom && parsedData.accountingYearTo) {
              setStartDate(new Date(parsedData.accountingYearFrom));
              setEndDate(new Date(parsedData.accountingYearTo));
            }

            // Set flags
            setIsFirstLoad(false);

            // If DSL No. and Year are available, call API to get fresh data on refresh
            if (parsedData.dslNo && parsedData.dslNo.length === 6 && parsedData.year) {
              console.log('🔄 Page refresh detected with DSL and Year - Calling API for fresh data');
              setIsDataLoaded(false);
              lastApiCallRef.current = { dslNo: '', year: '' };

              // Call API to fetch fresh data
              setTimeout(() => {
                fetchIdentificationData(parsedData.dslNo, parsedData.year);
              }, 100);
            } else {
              setIsDataLoaded(true);
              if (parsedData.dslNo && parsedData.year) {
                lastApiCallRef.current = { dslNo: parsedData.dslNo, year: parsedData.year };
              }
            }
          }
        } else {
          console.log('❌ No saved data found - Setting default values');

          // Auto-fill DSL No for FACTO role
          const initialDSL = isFACTO && userDSL ? userDSL : '';

          setFormData({
            year: '', scheduleDespatchNo: '', pslNo: '', schemeCode: '',
            industryCodeFrame: '', industryCodeReturn: '', descriptionOfIndustry: '',
            state: '', district: '', sector: '', roSroCode: '', numberOfUnits: '',
            statusOfUnit: '', nameUnit: '', addressUnit: '', villTown: '',
            districtName: '', stateName: '', pinCode: '', typeOfOrg: '', cin: '',
            isoCert: '', yearOfInitialProd: '', accountingYearFrom: '',
            accountingYearTo: '', monthsOfOperation: '', shareCapital: '',
            rdUnit: '', contactName: '', contactTele: '', contactFax: '',
            contactEmail: '', formalTraining: '', dslNo: initialDSL,
            verificationCompilationDate: formatDateDDMMYYYY(),
            entryMode: 'balanceSheet',
            documentPath: '', documentPathFull: '', uploadScheduleFileName: '',
            uploadScheduleFilePath: '', remarksBlock: '', remarksItems: '',
            remarks: '', remarksCreatedOn: '', remarksBy: '', remarksRole: ''
          });

          setStartDate(null);
          setEndDate(null);
          setErrors({ contactEmail: '', cin: '' });
          setIsFirstLoad(false);
          setIsDataLoaded(true);

          // Save current loginTime for next check
          if (currentLoginTime) {
            localStorage.setItem('balanceSheetLoginTime', currentLoginTime);
          }
        }
      } catch (error) {
        console.error('Error in route check:', error);
      }
    };

    loadDataWithRouteCheck();

    return () => {
      isMounted = false;
    };
  }, [getUserInfo, formatDateDDMMYYYY]);

  // Single useEffect for API calls with useMemo optimization
  useEffect(() => {
    if (shouldMakeApiCall) {
      console.log('Making API call for DSL:', formData.dslNo, 'Year:', formData.year);
      fetchIdentificationData(formData.dslNo, formData.year);
    }
  }, [shouldMakeApiCall, fetchIdentificationData, formData.dslNo, formData.year]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      try {
        const dataToSave = {
          ...formData,
          accountingYearFrom: startDate ? startDate.toISOString() : null,
          accountingYearTo: endDate ? endDate.toISOString() : null
        };
        localStorage.setItem('balanceSheetFormData', JSON.stringify(dataToSave));
        // Save loginTime to detect logout/login
        const currentLoginTime = localStorage.getItem('loginTime');
        if (currentLoginTime) {
          localStorage.setItem('balanceSheetLoginTime', currentLoginTime);
        }
      } catch (error) {
        console.error('Error saving form data to localStorage:', error);
      }
    }, 300); // 300ms debounce

    return () => clearTimeout(timeoutId);
  }, [formData, startDate, endDate]);

  const validateDSL = useCallback((dslNumber) => {
    let dslNo = dslNumber.toString();

    if (dslNo?.length === 0) {
      toast.error('DSL No. is mandatory', messages.COLOR_RED);
      return false;
    }
    else if (dslNo.length !== 6) {
      toast.error('DSL No. should be 6 digits', messages.COLOR_RED);
      return false;
    }
    else if (!/^\d{6}$/.test(dslNo)) {
      toast.error('DSL No. should contain only numbers', messages.COLOR_RED);
      return false;
    }
    else {
      return true;
    }
  }, []);

  // Function to call the save-complete-asiframe API
  const handleSaveCompleteAsiFrame = useCallback(async () => {
    const toastKey = 'save-api';

    if (!formData.dslNo || formData.dslNo.trim() === '') {
      if (!toastShownRef.current[`${toastKey}-dsl-mandatory`]) {
        toast.error('DSL No. is mandatory', messages.COLOR_RED);
        toastShownRef.current[`${toastKey}-dsl-mandatory`] = true;
        setTimeout(() => delete toastShownRef.current[`${toastKey}-dsl-mandatory`], 3000);
      }
      return false;
    }

    if (!formData.year || formData.year.trim() === '') {
      if (!toastShownRef.current[`${toastKey}-year-mandatory`]) {
        toast.error('Year is mandatory', messages.COLOR_RED);
        toastShownRef.current[`${toastKey}-year-mandatory`] = true;
        setTimeout(() => delete toastShownRef.current[`${toastKey}-year-mandatory`], 3000);
      }
      return false;
    }

    // Validate email
    const emailError = validateEmail(formData.contactEmail);
    if (emailError) {
      setErrors(prev => ({ ...prev, contactEmail: emailError }));
      const toastKey = 'save-email-error';
      if (!toastShownRef.current[toastKey]) {
        toast.error(emailError, messages.COLOR_RED);
        toastShownRef.current[toastKey] = true;
        setTimeout(() => delete toastShownRef.current[toastKey], 3000);
      }
      return false;
    }

    // Validate contact person mobile (if provided, must be 10 digits) - Check mobile first
    if (formData.contactPersonMobile && formData.contactPersonMobile.trim() !== '') {
      if (!/^\d{10}$/.test(formData.contactPersonMobile.trim())) {
        toast.dismiss(); // Dismiss any existing toasts
        toast.error('Mobile Number must be 10 digits for contact person', messages.COLOR_RED);
        return false;
      }
    }

    // Validate contact person email (if provided)
    if (formData.contactPersonEmail && formData.contactPersonEmail.trim() !== '') {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(formData.contactPersonEmail.trim())) {
        toast.dismiss(); // Dismiss any existing toasts
        toast.error('Please enter a valid Email Id for contact person', messages.COLOR_RED);
        return false;
      }
    }

    // Validate all mandatory fields (marked with *)
    const mandatoryFields = [
      { field: 'sector', name: 'Sector', value: formData.sector },
      { field: 'statusOfUnit', name: 'Status of Unit', value: formData.statusOfUnit },
      { field: 'nameUnit', name: 'Name', value: formData.nameUnit },
      { field: 'addressUnit', name: 'Address', value: formData.addressUnit },
      { field: 'villTown', name: 'Village / Town', value: formData.villTown },
      { field: 'districtName', name: 'District Name', value: formData.districtName },
      { field: 'pinCode', name: 'Pincode', value: formData.pinCode },
      { field: 'mobileNumber', name: 'Mobile Number', value: formData.mobileNumber },
      { field: 'typeOfOrg', name: 'Type of organisation', value: formData.typeOfOrg },
      { field: 'isoCert', name: 'Whether the unit has ISO Certification, 14000 Series', value: formData.isoCert },
      { field: 'yearOfInitialProd', name: 'Year of initial production', value: formData.yearOfInitialProd },
      { field: 'accountingYearFrom', name: 'Accounting Year (From)', value: formData.accountingYearFrom },
      { field: 'accountingYearTo', name: 'Accounting Year (To)', value: formData.accountingYearTo },
      { field: 'monthsOfOperation', name: 'No of months operation', value: formData.monthsOfOperation }
    ];

    // Check each mandatory field
    for (const mandatoryField of mandatoryFields) {
      if (!mandatoryField.value || mandatoryField.value.toString().trim() === '') {
        const toastKey = `save-${mandatoryField.field}-mandatory`;
        if (!toastShownRef.current[toastKey]) {
          toast.error(`${mandatoryField.name} is mandatory`, messages.COLOR_RED);
          toastShownRef.current[toastKey] = true;
          setTimeout(() => delete toastShownRef.current[toastKey], 3000);
        }
        return false;
      }
    }

    // Conditional validation for Remarks Block and Remarks
    // If either Block or Remarks has data, then both become mandatory
    const remarksBlockValue = formData.remarksBlock ? formData.remarksBlock.toString().trim() : '';
    const remarksValue = formData.remarks ? formData.remarks.toString().trim() : '';

    if (remarksBlockValue !== '' || remarksValue !== '') {
      // At least one has data, so both are mandatory
      if (!remarksBlockValue) {
        const toastKey = 'save-remarksBlock-mandatory';
        if (!toastShownRef.current[toastKey]) {
          toast.error('Remarks Block is mandatory', messages.COLOR_RED);
          toastShownRef.current[toastKey] = true;
          setTimeout(() => delete toastShownRef.current[toastKey], 3000);
        }
        return false;
      }

      if (!remarksValue) {
        const toastKey = 'save-remarks-mandatory';
        if (!toastShownRef.current[toastKey]) {
          toast.error('Remarks is mandatory', messages.COLOR_RED);
          toastShownRef.current[toastKey] = true;
          setTimeout(() => delete toastShownRef.current[toastKey], 3000);
        }
        return false;
      }
    }
    // If both are empty, no validation needed - data can be saved

    // Validate Pincode - exactly 6 digits
    if (formData.pinCode) {
      const pinCodeValue = formData.pinCode.toString().trim();
      if (!/^\d{6}$/.test(pinCodeValue)) {
        const toastKey = 'save-pinCode-invalid';
        if (!toastShownRef.current[toastKey]) {
          toast.error('Pincode must be 6 digits', messages.COLOR_RED);
          toastShownRef.current[toastKey] = true;
          setTimeout(() => delete toastShownRef.current[toastKey], 3000);
        }
        return false;
      }
    }

    // Validate Email Id - proper email format
    if (formData.emailId && formData.emailId.trim() !== '') {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(formData.emailId.trim())) {
        const toastKey = 'save-emailId-invalid';
        if (!toastShownRef.current[toastKey]) {
          toast.error('Please enter a valid Email Id', messages.COLOR_RED);
          toastShownRef.current[toastKey] = true;
          setTimeout(() => delete toastShownRef.current[toastKey], 3000);
        }
        return false;
      }
    }

    // Validate Mobile Number - exactly 10 digits
    if (formData.mobileNumber) {
      const mobileValue = formData.mobileNumber.toString().trim();
      if (!/^\d{10}$/.test(mobileValue)) {
        const toastKey = 'save-mobileNumber-invalid';
        if (!toastShownRef.current[toastKey]) {
          toast.error('Mobile Number must be 10 digits', messages.COLOR_RED);
          toastShownRef.current[toastKey] = true;
          setTimeout(() => delete toastShownRef.current[toastKey], 3000);
        }
        return false;
      }
    }

    // CIN validation removed - accepting any format

    showLoading(true);

    try {
      // Construct the payload according to API specification
      const payloadData = {
        dsl_no: formData.dslNo || "",
        survey_year: formData.year ? parseInt(formData.year.split('-')[0]) : null,
        Compilation_Date: formData.verificationCompilationDate || "",
        pslNo: formData.pslNo || "",
        schemeCode: formData.schemeCode || "",
        industryCodeReturn: formData.industryCodeReturn || "",
        industryCodeFrame: formData.industryCodeFrame || "",
        descriptionOfIndustry: formData.descriptionOfIndustry || "",
        state: formData.stateName || formData.state || "",
        district: formData.district || "",
        sector: formData.sector || "",
        numberOfUnits: formData.numberOfUnits ? parseInt(formData.numberOfUnits) : null,
        statusOfUnitCode: formData.statusOfUnit || "",
        statusFlag: formData.statusFlag || "",
        reason: formData.reason ? parseInt(formData.reason) : null,
        roSroCode: formData.roSroCode || "",
        typeOrganizationCode: formData.typeOfOrg || "",
        isoCertification14000: formData.isoCert || "",
        yearInitialProduction: formData.yearOfInitialProd ? parseInt(formData.yearOfInitialProd) : null,
        accountingYear: formData.year || "",
        accountingYearStart: formData.accountingYearFrom || "",
        accountingYearEnd: formData.accountingYearTo || "",
        numberOfMonthsOperation: formData.monthsOfOperation ? parseInt(formData.monthsOfOperation) : null,
        addressUnit: formData.addressUnit || formData.nameUnit || "",
        villTown: formData.villTown || "",
        districtName: formData.districtName || "",
        stateName: formData.stateName || "",
        pinCode: formData.pinCode || "",
        hasCIN: formData.hasCIN || "",
        email_id: formData.emailId || "",
        mobile_number: formData.mobileNumber || "",
        contactPersonName: formData.contactPersonName || "",
        contactPersonDesignation: formData.contactPersonDesignation || "",
        contactPersonEmail: formData.contactPersonEmail || "",
        contactPersonMobile: formData.contactPersonMobile || "",
        formalTraining: formData.formalTraining || "",
        shareCapital: formData.shareCapital ? parseFloat(formData.shareCapital) : null,
        rdUnit: formData.rdUnit || "",
        rdMaleEmployees: formData.rdMaleEmployees ? parseInt(formData.rdMaleEmployees) : 0,
        rdFemaleEmployees: formData.rdFemaleEmployees ? parseInt(formData.rdFemaleEmployees) : 0,
        rdTransgenderEmployees: formData.rdTransgenderEmployees ? parseInt(formData.rdTransgenderEmployees) : 0,
        trainingMaleEmployees: formData.trainingMaleEmployees ? parseInt(formData.trainingMaleEmployees) : null,
        trainingFemaleEmployees: formData.trainingFemaleEmployees ? parseInt(formData.trainingFemaleEmployees) : null,
        trainingTransgenderEmployees: formData.trainingTransgenderEmployees ? parseInt(formData.trainingTransgenderEmployees) : null,
        gstin: formData.gstin || "",
        items: formData.remarksItems || "",
        block: formData.remarksBlock || "",

        // dsl_no: formData.dslNo || "",
        // surveyYear: formData.year ? parseInt(formData.year.split('-')[0]) : null,
        // block: formData.remarksBlock,
        columnsName: '-',//formData.remarksItems || "",
        items: formData.remarksItems || "",
        remarks: formData.remarks || "",
        //formData.remarks || "",
        uploadedFile: formData.documentPath || ""
      };
      // payloadData.remarks.push({
      //   dsl_no: formData.dslNo || "",
      //   surveyYear: formData.year ? parseInt(formData.year.split('-')[0]) : null,
      //   block: formData.remarksBlock,
      //   columnsName: '-',//formData.remarksItems || "",
      //   items: formData.remarksItems || "",
      //   remarks: formData.remarks || ""
      // });

      // If file is uploaded, use FormData, otherwise use JSON payload
      let payload;
      let config = getConfig();

      if (uploadedFile || uploadScheduleFile) {
        // Create FormData for file upload
        const formDataPayload = new FormData();

        // Append all payload data to FormData (except uploadedFile, as we'll append the file object separately)
        Object.keys(payloadData).forEach(key => {
          if (key !== 'uploadedFile') { // Skip uploadedFile from payloadData as we'll append file object separately
            const value = payloadData[key];
            if (value !== null && value !== undefined) {
              if (typeof value === 'object' && !(value instanceof File)) {
                // console.log("===",value)
                formDataPayload.append(key, JSON.stringify(value));
              } else {
                formDataPayload.append(key, value);
              }
            }
          }
        });


        // Append the uploaded file with key 'uploadedFile' if exists
        if (uploadedFile) {
          formDataPayload.append('uploadedFile', uploadedFile);
        }

        // Append the schedule file with key 'uploadSchedule' if exists
        if (uploadScheduleFile) {
          formDataPayload.append('uploadSchedule', uploadScheduleFile);
        }

        payload = formDataPayload;

        // Remove Content-Type header to let browser set it automatically with boundary for FormData
        delete config.headers['Content-Type'];
      } else {
        payload = payloadData;
      }





      // console.log("AAAAAAAAAA");
      // console.log(payload); return false;
      const response = await axios.post(
        `${API_URL}api/identification-particulars/save-complete-asiframe`,
        payload,
        config
      );

      console.log('API Response:', response.data);

      if (response.data && response.data.status) {
        toast.success('Data saved successfully to ASI Frame!', messages.COLOR_RED);
        // Set flag to enable all pages in progress bar after save success
        localStorage.setItem('balanceSheetDataSaved', 'true');
        // Mark page as saved for green header
        markPageAsSaved(PAGE_NAMES.GENERAL_INFORMATION);
        // Refresh balance sheet validation to update header colors
        if (formData.dslNo && formData.year) {
          await refreshBalanceSheetValidation(formData.dslNo, formData.year);
        }
        return true;
      } else {
        toast.error(response.data.message || 'Failed to save data to ASI Frame', messages.COLOR_RED);
        return false;
      }

    } catch (error) {
      console.error('API Error:', error);
      const errorMessage = error.response?.data?.message || 'An error occurred while saving data to ASI Frame';
      toast.error(errorMessage, messages.COLOR_RED);
      return false;
    } finally {
      showLoading(false);
    }
  }, [autoResizeDescription, formData, validateEmail, getConfig]);


  return (
    <>

      {/* {isLoading && (
        <div className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center" style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 9999 }}>
          <div className="spinner-border text-light" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )} */}
      {/* Header Section with Title, Radio Buttons */}
      <div className="card mx-3 mb-3">
        <div className="card-body">
          <div className="row align-items-center">
            <div className="col-md-12">
              <h4 className="page_heading mb-0 pb-0 border-bottom-0">
                ASI Schedule 2024-25 <span style={{ color: '#d32f2f', fontWeight: 'bold' }}>CONFIDENTIAL <i className="fa fa-lock me-2" style={{ fontSize: '20px', color: '#1976d2' }}></i></span>
              </h4>
            </div>
          </div>
        </div>
      </div>

      {/* General Information Heading with Action Buttons */}
      <div className="mx-3">
        <div className="row align-items-center">
          <div className="col-md-6 mb-3">
            <h4 className="page_heading border-bottom-0 mb-0">
              <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? asiTitle.hi.GENERAL_INFORMATION : asiTitle.en.GENERAL_INFORMATION }} />
            </h4>
          </div>
          <div className="col-md-6 text-end mb-3">
            <button
              type="button"
              className="btn btn-success me-2"
              onClick={() => {
                const link = document.createElement('a');
                link.href = 'pdf/sampleSchedule.pdf';
                link.download = 'sampleSchedule.pdf';
                link.target = '_blank';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              }}
            >
              <i className="fa fa-file-text-o me-1"></i>
              <i className="fa fa-download me-1"></i> Download Schedule Template
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => {
                const input = document.createElement('input');
                input.type = 'file';
                input.accept = '.pdf,.xls,.xlsx';
                input.onchange = (e) => {
                  const file = e.target.files[0];
                  if (file) {
                    // Validate file extension - Only PDF and Excel files allowed
                    const allowedExtensions = ['.pdf', '.xls', '.xlsx'];
                    const fileExtension = '.' + file.name.split('.').pop().toLowerCase();

                    if (!allowedExtensions.includes(fileExtension)) {
                      toast.error('Allowed Extensions: .pdf, .xls, .xlsx only', messages.COLOR_RED);
                      return;
                    }

                    // Validate file size (20MB = 20 * 1024 * 1024 bytes)
                    const maxSize = 20 * 1024 * 1024; // 20MB in bytes
                    if (file.size > maxSize) {
                      toast.error('Max Size: 20MB', messages.COLOR_RED);
                      return;
                    }

                    // If validation passes, store the file object and file name
                    setUploadScheduleFile(file);
                    setFormData(prev => ({ ...prev, uploadScheduleFileName: file.name }));
                  }
                };
                input.click();
              }}
            >
              <i className="fa fa-upload me-1"></i>
              Upload Schedule
            </button>
            {formData.uploadScheduleFileName && uploadScheduleFile && (
              <div className="mt-2 position-relative">
                <small className="text-muted">
                  <i className="fa fa-file me-1"></i>
                  Selected file: <strong>{formData.uploadScheduleFileName}</strong>
                </small>
                <button
                  type="button"
                  className="btn btn-sm btn-success position-absolute end-0"
                  style={{
                    top: '50%',
                    transform: 'translateY(-50%)',
                    backgroundColor: '#28a745',
                    borderColor: '#28a745',
                    color: '#fff'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#218838';
                    e.target.style.borderColor = '#1e7e34';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = '#28a745';
                    e.target.style.borderColor = '#28a745';
                  }}
                  onClick={() => {
                    // Download the uploaded file
                    if (uploadScheduleFile) {
                      const url = window.URL.createObjectURL(uploadScheduleFile);
                      const link = document.createElement('a');
                      link.href = url;
                      link.download = uploadScheduleFile.name;
                      document.body.appendChild(link);
                      link.click();
                      document.body.removeChild(link);
                      window.URL.revokeObjectURL(url);
                      toast.success('Schedule file downloaded successfully', messages.COLOR_RED);
                    }
                  }}
                >
                  <i className="fa fa-download me-1"></i>
                  Download
                </button>
              </div>
            )}
          </div>
        </div>
      </div>


      {/* Block A and Block B - Two Column Layout */}
      <div className="mx-3">
        <div className="row">
          {/* Block A - Left Card (Read-only fields) */}
          <div className="col-xl-6 mb-3">
            <div className="card mb-3">
              <div className="card-body">
                <h5 className="card-title mb-4 border-bottom pb-2">Block A</h5>
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="w-100" htmlFor="verificationDate">Verification/Compilation Date</label>
                    <input
                      type="text"
                      name="verificationCompilationDate"
                      id="verificationDate"
                      className="form-control"
                      placeholder="DD/MM/YYYY"
                      value={formData.verificationCompilationDate || ''}
                      onChange={handleChange}
                      disabled
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label htmlFor="year">Survey Year</label>
                    <select className="form-select" id="year" name="year" value={formData.year} onChange={handleChange}>
                      <option value="">Select</option>
                      {(() => {
                        const currentDate = new Date();
                        const currentYear = currentDate.getFullYear();
                        const currentMonth = currentDate.getMonth();
                        let currentFinancialYear;
                        if (currentMonth >= 3) {
                          currentFinancialYear = currentYear;
                        } else {
                          currentFinancialYear = currentYear - 1;
                        }
                        const maxYear = currentFinancialYear - 1;
                        const years = [];
                        for (let year = maxYear; year >= 2021; year--) {
                          years.push(
                            <option key={year} value={`${year}-${(year + 1).toString().slice(-2)}`}>
                              {year}-{(year + 1).toString().slice(-2)}
                            </option>
                          );
                        }
                        return years;
                      })()}
                    </select>
                  </div>
                  <div className="col-md-6 mb-3">
                    <label htmlFor="dslNo"><span className='badge bg-secondary'>1</span> DSL No.</label>
                    <input
                      type="text"
                      name="dslNo"
                      id="dslNo"
                      className="form-control"
                      placeholder="Enter DSL No."
                      maxLength="6"
                      value={formData.dslNo}
                      onChange={handleChange}
                      onBlur={(e) => validateDSL(e.target.value)}
                      disabled={(() => {
                        const userInfo = getUserInfo();
                        return userInfo && userInfo.ROLE_CODE === 'FACTO';
                      })()}
                      style={(() => {
                        const userInfo = getUserInfo();
                        return userInfo && userInfo.ROLE_CODE === 'FACTO'
                          ? { backgroundColor: '#f5f5f5', cursor: 'not-allowed' }
                          : {};
                      })()}
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label htmlFor="pslNo"><span className='badge bg-secondary'>2</span> PSL No.</label>
                    <input type="text" className="form-control" id="pslNo" name="pslNo" value={formData.pslNo} onChange={handleChange} disabled />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label htmlFor="schemeCode"><span className='badge bg-secondary'>3</span> Scheme</label>
                    <input type="text" className="form-control" id="schemeCode" name="schemeCode" value={formData.schemeCode} onChange={handleChange} disabled />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label htmlFor="industryCodeFrame"><span className='badge bg-secondary'>4</span> Industry code as per Frame</label>
                    <input type="text" className="form-control" id="industryCodeFrame" name="industryCodeFrame" value={formData.industryCodeFrame} onChange={handleChange} disabled />
                    <small className="text-muted">4-digit level of NIC-08</small>
                  </div>
                  <div className="col-md-6 mb-3">
                    <label htmlFor="industryCodeReturn" id="industryCodeReturn-label"><span className='badge bg-secondary'>5</span> Industry code as per Return</label>
                    <IndustryCodeReturnDropdown
                      options={industryCodeReturnList}
                      value={formData.industryCodeReturn}
                      onChange={handleChange}
                      id="industryCodeReturn"
                      name="industryCodeReturn"
                      placeholder="Select Industry Code"
                    />
                    <small className="text-muted">5-digit level of NIC-08</small>
                  </div>
                  <div className="col-md-6 mb-3">
                    <label htmlFor="descriptionOfIndustry"><span className='badge bg-secondary'>6</span> Description of Industry</label>
                    <textarea
                      ref={descriptionRef}
                      className="form-control description-textarea"
                      id="descriptionOfIndustry"
                      name="descriptionOfIndustry"
                      value={formData.descriptionOfIndustry}
                      onChange={handleChange}
                      disabled
                      rows="3"
                      maxLength={(() => {
                        const is2024Year = !formData.year || formData.year.startsWith('2024');
                        return is2024Year ? 200 : 500;
                      })()}
                      placeholder={(() => {
                        const is2024Year = !formData.year || formData.year.startsWith('2024');
                        return is2024Year ? "Enter description of industry (max 200 characters)" : "Enter description of industry (max 500 characters)";
                      })()}
                      style={{ resize: 'vertical', minHeight: '80px', overflow: 'hidden' }}
                    />
                    <small className="text-muted">
                      {formData.descriptionOfIndustry.length}/{(() => {
                        const is2024Year = !formData.year || formData.year.startsWith('2024');
                        return is2024Year ? 200 : 500;
                      })()} characters
                    </small>
                  </div>
                  <div className="col-md-6 mb-3">
                    <label htmlFor="stateName"><span className='badge bg-secondary'>7</span> State/UT master</label>
                    <input type="text" className="form-control" id="stateName" name="stateName" value={formData.stateName} onChange={handleChange} disabled />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label htmlFor="district"><span className='badge bg-secondary'>8</span> District</label>
                    <input type="text" className="form-control" id="district" name="district" value={formData.district} onChange={handleChange} disabled />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label htmlFor="sector"><span className='badge bg-secondary'>9</span> Sector <span style={{ color: 'red' }}>*</span></label>
                    <select className="form-select" id="sector" name="sector" value={formData.sector} onChange={handleChange}>
                      <option value="">Select</option>
                      <option value="1">Rural</option>
                      <option value="2">Urban</option>
                    </select>
                    <small className="text-muted">For Next Year Frame Updation</small>
                  </div>
                  <div className="col-md-6 mb-3">
                    <label htmlFor="roSroCode"><span className='badge bg-secondary'>10</span> RO / SRO Code</label>
                    <input type="text" className="form-control" id="roSroCode" name="roSroCode" value={formData.roSroCode} onChange={handleChange} disabled />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label htmlFor="numberOfUnits"><span className='badge bg-secondary'>11</span> No. of Units</label>
                    <input type="text" className="form-control" id="numberOfUnits" name="numberOfUnits" value={formData.numberOfUnits} onChange={handleChange} disabled />
                    <small className="text-primary" style={{ cursor: 'pointer' }}>View Joint Units</small>
                  </div>
                  <div className="col-md-6 mb-3">
                    <label htmlFor="statusOfUnit" id="statusOfUnit-label"><span className='badge bg-secondary'>12</span> Status of Unit <span style={{ color: 'red' }}>*</span></label>
                    <StatusUnitDropdown
                      options={unitCodes}
                      value={formData.statusOfUnit}
                      onChange={handleChange}
                      id="statusOfUnit"
                      name="statusOfUnit"
                      placeholder="Select"
                    />
                    <small className="text-muted">For Next Year Frame Updation</small>
                  </div>
                </div>

                {/* Upload/Download Supported Documents Section */}
                <div className="row mt-4">
                  <div className="col-12">
                    <h6 className="mb-3">Upload/Download Supported Documents</h6>
                    <div className="d-flex gap-2 mb-2">
                      <input
                        type="text"
                        className="form-control"
                        id="documentPath"
                        name="documentPath"
                        value={formData.documentPath || ''}
                        onChange={handleChange}
                        placeholder="No file selected"
                        readOnly
                      />
                      <button
                        type="button"
                        className="btn btn-outline-primary d-flex align-items-center"
                        style={{ color: '#000' }}
                        onClick={() => {
                          const input = document.createElement('input');
                          input.type = 'file';
                          input.accept = '.pdf,.xls,.xlsx';
                          input.onchange = (e) => {
                            const file = e.target.files[0];
                            if (file) {
                              // Validate file extension
                              const allowedExtensions = ['.pdf', '.xls', '.xlsx'];
                              const fileExtension = '.' + file.name.split('.').pop().toLowerCase();

                              if (!allowedExtensions.includes(fileExtension)) {
                                toast.error('Allowed Extensions: .pdf, .xls, .xlsx', messages.COLOR_RED);
                                return;
                              }

                              // Validate file size (20MB = 20 * 1024 * 1024 bytes)
                              const maxSize = 20 * 1024 * 1024; // 20MB in bytes
                              if (file.size > maxSize) {
                                toast.error('Max Size: 20MB', messages.COLOR_RED);
                                return;
                              }

                              // If validation passes, set the file name and store file object
                              setFormData({ ...formData, documentPath: file.name });
                              setUploadedFile(file); // Store the actual file object
                              toast.success('File selected successfully', messages.COLOR_RED);
                            }
                          };
                          input.click();
                        }}
                      >
                        <i className="fa fa-file-upload me-1"></i>
                        Browse
                      </button>
                      {formData.documentPathFull && (
                        <button
                          type="button"
                          className="btn btn-outline-success d-flex align-items-center"
                          style={{ color: '#000' }}
                          onClick={() => {
                            // Download file from server
                            const filePath = formData.documentPathFull;
                            const downloadUrl = `${API_URL}${filePath}`;

                            // Create a temporary anchor element to trigger download
                            const link = document.createElement('a');
                            link.href = downloadUrl;
                            link.download = formData.documentPath || 'document';
                            link.target = '_blank';

                            // Add authorization header if needed
                            const token = localStorage.getItem('token') || localStorage.getItem('jwt') || localStorage.getItem('accessToken');
                            if (token) {
                              // For file downloads, we'll use fetch with authorization
                              fetch(downloadUrl, {
                                headers: {
                                  'Authorization': `Bearer ${token}`
                                }
                              })
                                .then(response => {
                                  if (response.ok) {
                                    return response.blob();
                                  }
                                  throw new Error('Failed to download file');
                                })
                                .then(blob => {
                                  const url = window.URL.createObjectURL(blob);
                                  link.href = url;
                                  document.body.appendChild(link);
                                  link.click();
                                  document.body.removeChild(link);
                                  window.URL.revokeObjectURL(url);
                                  toast.success('File downloaded successfully', messages.COLOR_RED);
                                })
                                .catch(error => {
                                  console.error('Download error:', error);
                                  toast.error('Failed to download file', messages.COLOR_RED);
                                });
                            } else {
                              // If no token, try direct download
                              document.body.appendChild(link);
                              link.click();
                              document.body.removeChild(link);
                            }
                          }}
                        >
                          <i className="fa fa-download me-1"></i>
                          Download
                        </button>
                      )}
                    </div>
                    <small className="text-muted">Allowed Extensions: .pdf, .xls, .xlsx. Max Size: 20MB.</small>
                  </div>
                </div>

              </div>
            </div>
            {/* Remarks Section - Below Block B, same width as Block B */}
            <div className="card">
              <div className="card-body">
                <h6 className="mb-3" style={{ fontWeight: 'bold' }}>Remarks</h6>
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label htmlFor="remarksBlock">Block <span style={{ color: 'red' }}>*</span></label>
                    <select className="form-select" id="remarksBlock" name="remarksBlock" value={formData.remarksBlock || ''} onChange={handleChange}>
                      <option value="">Select Block</option>
                      <option value="ALL">ALL</option>
                      <option value="A">Block A</option>
                      <option value="B">Block B</option>
                    </select>
                  </div>
                  <div className="col-md-6 mb-3">
                    <label htmlFor="remarksItems">Items</label>
                    <select className="form-select" id="remarksItems" name="remarksItems" value={formData.remarksItems || ''} onChange={handleChange}>
                      <option value="">Select Item</option>
                      <option value="1">Item 1</option>
                      <option value="2">Item 2</option>
                      <option value="3">Item 3</option>
                      <option value="4">Item 4</option>
                      <option value="5">Item 5</option>
                      <option value="6">Item 6</option>
                      <option value="7">Item 7</option>
                      <option value="8">Item 8</option>
                      <option value="9">Item 9</option>
                      <option value="10">Item 10</option>
                      <option value="11">Item 11</option>
                      <option value="12">Item 12</option>
                    </select>
                  </div>
                  <div className="col-md-12 mb-3">
                    <label htmlFor="remarks">Remarks<span style={{ color: 'red' }}>*</span></label>
                    <textarea
                      className="form-control"
                      id="remarks"
                      name="remarks"
                      value={formData.remarks || ''}
                      onChange={handleChange}
                      rows="4"
                      maxLength="1000"
                      placeholder="Enter Remarks..."
                      style={{ resize: 'vertical' }}
                    />
                    <div className="d-flex justify-content-between align-items-center mt-1">
                      <small className="text-muted">
                        <i className="fa fa-info-circle me-1"></i>
                        Remarks will hold 1000 characters
                      </small>
                      <small className="text-muted">
                        {formData.remarks?.length || 0}/1000
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Block B - Right Card (Owner input fields) */}
          <div className="col-xl-6 mb-3">
            <div className="card h-100">
              <div className="card-body">
                <h5 className="card-title mb-4 border-bottom pb-2">Block B</h5>

                <h6 className="mb-2" style={{ fontWeight: 'bold', fontSize: '16px' }}><span class="badge bg-secondary">1</span> Particulars of the factory</h6>
                <p className="text-muted small mb-4">To be filled by owner of the factory</p>
                <div class="card mb-3">
                  <div class="card-body">
                    <div className="row">
                      <div className="col-md-6">
                        {/* Name* */}
                        <div className="mb-3">
                          <label htmlFor="nameUnit">Name<span style={{ color: 'red' }}>*</span></label>
                          <input type="text" className="form-control" id="nameUnit" name="nameUnit" value={formData.nameUnit} onChange={handleChange} maxLength="100" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        {/* Address* */}
                        <div className="mb-3">
                          <label htmlFor="addressUnit">Address<span style={{ color: 'red' }}>*</span></label>
                          <textarea
                            className="form-control"
                            id="addressUnit"
                            name="addressUnit"
                            value={formData.addressUnit}
                            onChange={handleChange}
                            rows="3"
                            maxLength="500"
                            placeholder="Enter address"
                          />
                          <small className="text-muted">
                            <i className="fa fa-info-circle me-1"></i>
                            Address will hold 500 characters
                          </small>
                        </div>
                      </div>
                      <div className="col-md-6">
                        {/* Village / Town* */}
                        <div className="mb-3">
                          <label htmlFor="villTown">Village / Town<span style={{ color: 'red' }}>*</span></label>
                          <input
                            type="text"
                            className="form-control"
                            id="villTown"
                            name="villTown"
                            value={formData.villTown}
                            onChange={handleChange}
                            maxLength="100"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        {/* District Name * */}
                        <div className="mb-3">
                          <label htmlFor="districtName">District Name <span style={{ color: 'red' }}>*</span></label>
                          <select className="form-select" id="districtName" name="districtName" value={formData.districtName} onChange={handleChange}>
                            <option value="">Select District</option>
                            <option value={formData.districtName}>{formData.districtName}</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-md-6">
                        {/* State Name */}
                        <div className="mb-3">
                          <label htmlFor="stateName">State Name</label>
                          <input type="text" className="form-control" id="stateName" name="stateName" value={formData.stateName} onChange={handleChange} disabled style={{ backgroundColor: '#f5f5f5' }} />
                        </div>
                      </div>
                      <div className="col-md-6">
                        {/* Pincode * */}
                        <div className="mb-3">
                          <label htmlFor="pinCode">Pincode <span style={{ color: 'red' }}>*</span></label>
                          <input
                            type="text"
                            className="form-control"
                            id="pinCode"
                            name="pinCode"
                            value={formData.pinCode}
                            onChange={handleChange}
                            onBlur={(e) => {
                              const value = e.target.value;
                              if (value && value.trim() !== '') {
                                if (!/^\d{6}$/.test(value.trim())) {
                                  toast.error('Pincode must be 6 digits', messages.COLOR_RED);
                                }
                              }
                            }}
                            maxLength="6"
                            placeholder="Enter 6 digit pin code"
                            pattern="[0-9]*"
                            inputMode="numeric"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        {/* Email Id */}
                        <div className="mb-3">
                          <label htmlFor="emailId">Email Id</label>
                          <input
                            type="email"
                            className="form-control"
                            id="emailId"
                            name="emailId"
                            value={formData.emailId}
                            onChange={handleChange}
                            onBlur={(e) => {
                              const value = e.target.value;
                              if (value && value.trim() !== '') {
                                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                                if (!emailRegex.test(value.trim())) {
                                  toast.error('Please enter a valid Email Id', messages.COLOR_RED);
                                }
                              }
                            }}
                            maxLength="100"
                            placeholder="Enter company email"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">

                        {/* Mobile Number * */}
                        <div className="mb-3">
                          <label htmlFor="mobileNumber">Mobile Number <span style={{ color: 'red' }}>*</span></label>
                          <input
                            type="text"
                            className="form-control"
                            id="mobileNumber"
                            name="mobileNumber"
                            value={formData.mobileNumber}
                            onChange={handleChange}
                            onBlur={(e) => {
                              const value = e.target.value;
                              if (value && value.trim() !== '') {
                                if (!/^\d{10}$/.test(value.trim())) {
                                  toast.error('Mobile Number must be 10 digits', messages.COLOR_RED);
                                }
                              }
                            }}
                            maxLength="10"
                            placeholder="Enter Mobile Number"
                            pattern="[0-9]*"
                            inputMode="numeric"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>


                <div className="row">
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label htmlFor="typeOfOrg"><span class="badge bg-secondary">2</span> Type of organisation<span style={{ color: 'red' }}>*</span></label>
                      <select className="form-select" id="typeOfOrg" name="typeOfOrg" value={formData.typeOfOrg} onChange={handleChange}>
                        <option value="">Select Organization</option>
                        <option value="1">Individual Proprietorship</option>
                        <option value="2">Partnership</option>
                        <option value="3">Limited Liability Partnership</option>
                        <option value="4">Government Company - Public</option>
                        <option value="5">Government Company - Private</option>
                        <option value="6">Non-Government Company - Public</option>
                        <option value="7">Non-Government Company - Private</option>
                        <option value="8">Co-operative Society</option>
                        <option value="9">Others (including Joint Family (HUF), Trust)</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label htmlFor="cin"><span class="badge bg-secondary">3</span> CIN</label>
                      <input
                        type="text"
                        className="form-control"
                        id="cin"
                        name="cin"
                        value={formData.cin}
                        onChange={handleChange}
                        maxLength="25"
                        disabled
                        style={{ backgroundColor: '#f5f5f5' }}
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label htmlFor="isoCert"><span class="badge bg-secondary">4</span> Whether the unit has ISO Certification, 14000 Series<span style={{ color: 'red' }}>*</span></label>
                      <select className="form-select" id="isoCert" name="isoCert" value={formData.isoCert} onChange={handleChange}>
                        <option value="">Select</option>
                        <option value="1">Yes</option>
                        <option value="2">No</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label htmlFor="yearOfInitialProd"><span class="badge bg-secondary">5</span> Year of initial production<span style={{ color: 'red' }}>*</span></label>
                      <input
                        type="text"
                        className="form-control"
                        id="yearOfInitialProd"
                        name="yearOfInitialProd"
                        value={formData.yearOfInitialProd}
                        onChange={handleChange}
                        maxLength="4"
                        placeholder="Select Year"
                        pattern="[0-9]*"
                        inputMode="numeric"
                      />
                      <small className="text-muted">FORMAT "YYYY"</small>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label htmlFor="accountingYear"><span class="badge bg-secondary">6</span> Accounting Year<span style={{ color: 'red' }}>*</span></label>
                      <div className="d-flex align-items-center gap-2">
                        <input
                          type="text"
                          className="form-control"
                          id="accountingYearFrom"
                          name="accountingYearFrom"
                          value={formData.accountingYearFrom}
                          onChange={handleChange}
                          maxLength="5"
                          placeholder="MM/YY"
                          pattern="[0-9/]*"
                        />
                        <span>To</span>
                        <input
                          type="text"
                          className="form-control"
                          id="accountingYearTo"
                          name="accountingYearTo"
                          value={formData.accountingYearTo}
                          onChange={handleChange}
                          maxLength="5"
                          placeholder="MM/YY"
                          pattern="[0-9/]*"
                        />
                      </div>
                      <small className="text-muted">FORMAT "(MM/YY)"</small>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label htmlFor="monthsOfOperation"><span class="badge bg-secondary">7</span> No of months operation<span style={{ color: 'red' }}>*</span></label>
                      <input
                        type="text"
                        className="form-control"
                        id="monthsOfOperation"
                        name="monthsOfOperation"
                        value={formData.monthsOfOperation}
                        onChange={handleChange}
                        maxLength="2"
                        pattern="[0-9]*"
                        inputMode="numeric"
                      />
                    </div>
                  </div>
                  <div className="col-12 mb-3">
                    <label htmlFor="shareCapital"><span class="badge bg-secondary">8</span> Whether the share capital of the company includes share of foreign entities (Yes-1, No-2)</label>
                    <select className="form-select" id="shareCapital" name="shareCapital" value={formData.shareCapital} onChange={handleChange}>
                      <option value="" disabled>Select</option>
                      <option value="1">Yes</option>
                      <option value="2">No</option>
                    </select>
                  </div>
                  <div className="col-12 mb-3">
                    <label htmlFor="rdUnit"><span class="badge bg-secondary">9</span> Any RD unit in your factory (Yes registered with DST/DBT-1, Yes registered with others-2, no-3)</label>
                    <select className="form-select" id="rdUnit" name="rdUnit" value={formData.rdUnit} onChange={handleChange}>
                      <option value="" disabled>Select</option>
                      <option value="1">Yes registered with DST/DBT-1</option>
                      <option value="2">Yes registered with others-2</option>
                      <option value="3">No-3</option>
                    </select>
                    <small class="text-muted"><i class="fa fa-info-circle me-1"></i>If yes & registered with DSIR- 1 or yes & registered with other - 2 in item no. 9. number of employees engaged in R&D activity</small>
                  </div>
                  <div class="col-md-4 mb-3">
                    <label>Male</label>
                    <input type="text" class="form-control" placeholder="0" name="male" maxlength="100" value="" disabled />
                  </div>
                  <div class="col-md-4 mb-3">
                    <label>Female</label>
                    <input type="text" class="form-control" placeholder="0" name="female" maxlength="100" value="" disabled />
                  </div>
                  <div class="col-md-4 mb-3">
                    <label>Transgender</label>
                    <input type="text" class="form-control" placeholder="0" name="transgender" maxlength="100" value="" disabled />
                  </div>
                  <div className="col-12 mb-3">
                    <h6 className="mb-2" style={{ fontWeight: 'bold', fontSize: '16px' }}><span class="badge bg-secondary">10</span> Details of contact person</h6>
                  </div>

                </div>
                <div class="card mb-3">
                  <div class="card-body">
                    <div className="row">

                      {/* For 2024-2025: Show separate fields */}
                      {(() => {
                        const is2024Year = !formData.year || formData.year.startsWith('2024');
                        if (is2024Year) {
                          return (
                            <>
                              <div className="col-md-6 mb-3">
                                <label>Name</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Contact person name"
                                  name="contactPersonName"
                                  value={formData.contactPersonName}
                                  onChange={handleChange}
                                  maxLength="100"
                                />
                              </div>
                              <div className="col-md-6 mb-3">
                                <label>Designation</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Designation"
                                  name="contactPersonDesignation"
                                  value={formData.contactPersonDesignation}
                                  onChange={handleChange}
                                  maxLength="100"
                                />
                              </div>
                              <div className="col-md-6 mb-3">
                                <label>Email Id</label>
                                <input
                                  type="email"
                                  className="form-control"
                                  placeholder="Email address"
                                  name="contactPersonEmail"
                                  value={formData.contactPersonEmail}
                                  onChange={handleChange}
                                  maxLength="100"
                                  onBlur={(e) => {
                                    const value = e.target.value;
                                    if (value && value.trim() !== '') {
                                      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                                      if (!emailRegex.test(value.trim())) {
                                        toast.dismiss();
                                        toast.error('Please enter a valid Email Id', messages.COLOR_RED);
                                      }
                                    }
                                  }}
                                />
                              </div>
                              <div className="col-md-6 mb-3">
                                <label>Mobile Number</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Mobile number"
                                  name="contactPersonMobile"
                                  value={formData.contactPersonMobile}
                                  onChange={handleChange}
                                  maxLength="10"
                                  pattern="[0-9]*"
                                  inputMode="numeric"
                                  onBlur={(e) => {
                                    const value = e.target.value;
                                    if (value && value.trim() !== '') {
                                      if (!/^\d{10}$/.test(value.trim())) {
                                        toast.dismiss();
                                        toast.error('Mobile Number must be 10 digits', messages.COLOR_RED);
                                      }
                                    }
                                  }}
                                />
                              </div>
                            </>
                          );
                        } else {
                          return (
                            <>
                              <div className="col-md-6 mb-3">
                                <label>Name and Designation</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder=""
                                  name="contactName"
                                  value={formData.contactName}
                                  onChange={handleChange}
                                  maxLength="100"
                                  pattern="[a-zA-Z\s\.\-]+"
                                  title="Only letters, spaces, dots, and hyphens are allowed"
                                />
                              </div>
                              <div className="col-md-6 mb-3">
                                <label>Tele (With STD Code)</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="+91-123-456-7890"
                                  name="contactTele"
                                  value={formData.contactTele}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    const allowedPattern = /^[+\d-]*$/;
                                    if (allowedPattern.test(value) || value === '') {
                                      const cleanedValue = value.replace(/[-]+/g, '-');
                                      setFormData({ ...formData, contactTele: cleanedValue });
                                    } else {
                                      toast.error('Only numbers, + and -  are allowed', messages.COLOR_RED);
                                    }
                                  }}
                                  onBlur={(e) => {
                                    const value = e.target.value;
                                    if (value && value.trim() !== '') {
                                      const digitCount = (value.match(/\d/g) || []).length;
                                      if (digitCount < 10) {
                                        toast.error('Phone number Should be 10 digits Only', messages.COLOR_RED);
                                      }
                                    }
                                  }}
                                  maxLength="13"
                                />
                              </div>
                            </>
                          );
                        }
                      })()}

                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 mb-3">
                    <label htmlFor="formalTraining"><span class="badge bg-secondary">11</span> Whether the unit offered any formal training?</label>
                    <select className="form-select" id="formalTraining" name="formalTraining" value={formData.formalTraining} onChange={handleChange}>
                      <option value="" disabled>Select</option>
                      <option value="1">Yes</option>
                      <option value="2">No</option>
                    </select>
                  </div>
                  {/* Training Employee counts - Show only for 2024-2025 when Training is Yes (1) */}
                  {(() => {
                    const is2024Year = !formData.year || formData.year.startsWith('2024');
                    const showTrainingEmployees = is2024Year && formData.formalTraining === '1';

                    if (showTrainingEmployees) {
                      return (
                        <>
                          <div className="col-12 mb-2 mt-2">
                          <small class="text-muted"><i class="fa fa-info-circle me-1"></i>If yes, number of employees received formal training</small>
                          </div>
                          <div className="col-md-4 mb-3">
                            <label htmlFor="trainingMaleEmployees">11.1 Male</label>
                            <input
                              type="text"
                              className="form-control"
                              id="trainingMaleEmployees"
                              name="trainingMaleEmployees"
                              maxLength="6"
                              value={formData.trainingMaleEmployees}
                              onChange={handleChange}
                              placeholder="Number of employees"
                            />
                          </div>
                          <div className="col-md-4 mb-3">
                            <label htmlFor="trainingFemaleEmployees">11.2 Female</label>
                            <input
                              type="text"
                              className="form-control"
                              id="trainingFemaleEmployees"
                              name="trainingFemaleEmployees"
                              maxLength="6"
                              value={formData.trainingFemaleEmployees}
                              onChange={handleChange}
                              placeholder="Number of employees"
                            />
                          </div>
                          <div className="col-md-4 mb-3">
                            <label htmlFor="trainingTransgenderEmployees">11.3 Transgender</label>
                            <input
                              type="text"
                              className="form-control"
                              id="trainingTransgenderEmployees"
                              name="trainingTransgenderEmployees"
                              maxLength="6"
                              value={formData.trainingTransgenderEmployees}
                              onChange={handleChange}
                              placeholder="Number of employees"
                            />
                          </div>
                        </>
                      );
                    }
                    return null;
                  })()}
                  {/* GSTIN - Show only for 2024-2025 */}
                  {(() => {
                    const is2024Year = !formData.year || formData.year.startsWith('2024');
                    if (is2024Year) {
                      return (
                        <div className="col-12 mb-3">
                          <label htmlFor="gstin"><span class="badge bg-secondary">12</span> Goods and Services Tax Identification Number (GSTIN)</label>
                          <input
                            type="text"
                            className="form-control"
                            id="gstin"
                            name="gstin"
                            maxLength="15"
                            value={formData.gstin}
                            onChange={handleChange}
                            placeholder="GSTIN (15 characters)"
                          />
                        </div>
                      );
                    }
                    return null;
                  })()}
                </div>
              </div>
            </div>

          </div>



        </div>
      </div>




      {/* <div className="card mx-3 mb-3">
          <div className="card-body">
            <div className="row">
              <div className="col-md-6">
                <div className="row">
                  <div className="col-12 mb-3">
                    <label htmlFor="state">State</label>
                    <input type="text" className="form-control" id="state" name="state" value={formData.state} onChange={handleChange} disabled />
                  </div>
                  <div className="col-12 mb-3">
                    <label htmlFor="district">District</label>
                    <input type="text" className="form-control" id="district" name="district" value={formData.district} onChange={handleChange} disabled />
                  </div>
                  {(() => {
                    const is2024Year = !formData.year || formData.year.startsWith('2024');
                    if (is2024Year) {
                      return (
                        <div className="col-12 mb-3">
                          <label htmlFor="stateCode">State Code</label>
                          <input type="text" className="form-control" id="stateCode" name="stateCode" value={formData.stateCode} onChange={handleChange} maxLength="5" />
                        </div>
                      );
                    }
                    return null;
                  })()}
                  <div className="col-12 mb-3">
                    <label htmlFor="sector">Sector</label>
                    <select className="form-select" id="sector" name="sector" value={formData.sector} onChange={handleChange}>
                      <option value="" disabled>Select</option>
                      <option value="1">Rural</option>
                      <option value="2">Urban</option>
                    </select>
                  </div>
                  <div className="col-12 mb-3">
                    <label htmlFor="roSroCode">RO / SRO Code</label>
                    <input type="text" className="form-control" id="roSroCode" name="roSroCode" value={formData.roSroCode} onChange={handleChange} disabled />
                  </div>
                  <div className="col-12 mb-3">
                    <label htmlFor="numberOfUnits">No. of Units</label>
                    <input type="text" className="form-control" id="numberOfUnits" name="numberOfUnits" value={formData.numberOfUnits} onChange={handleChange} disabled />
                  </div>
                  <div className="col-12 mb-3">
                    <label htmlFor="statusOfUnitPrint" id="statusOfUnitPrint-label">Status of Unit</label>
                    <StatusUnitDropdown
                      options={unitCodes}
                      value={formData.statusOfUnit}
                      onChange={handleChange}
                      id="statusOfUnitPrint"
                      name="statusOfUnit"
                      placeholder="Select"
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="row">
                  <div className="col-12 mb-3">
                    <label htmlFor="typeOfOrg">Type of Organisation</label>
                    <select className="form-select" id="typeOfOrg" name="typeOfOrg" value={formData.typeOfOrg} onChange={handleChange}>
                      <option value="" disabled>Organisation Details</option>
                      <option value="1">Individual Proprietorship</option>
                      <option value="2">Partnership</option>
                      <option value="3">Limited Liability Partnership</option>
                      <option value="4">Government Company - Public</option>
                      <option value="5">Government Company - Private</option>
                      <option value="6">Non-Government Company - Public</option>
                      <option value="7">Non-Government Company - Private</option>
                      <option value="8">Co-operative Society</option>
                      <option value="9">Others (including Joint Family (HUF), Trust)</option>
                    </select>
                  </div>
                  {(() => {
                    const is2024Year = !formData.year || formData.year.startsWith('2024');
                    if (is2024Year) {
                      return (
                        <>
                          <div className="col-12 mb-3">
                            <label htmlFor="hasCIN">Do you have Corporate Identification Number (CIN)?</label>
                            <select className="form-select" id="hasCIN" name="hasCIN" value={formData.hasCIN} onChange={handleChange}>
                              <option value="">Select</option>
                              <option value="1">1 - Yes</option>
                              <option value="2">2 - No</option>
                            </select>
                          </div>
                          {formData.hasCIN === '1' && (
                            <div className="col-12 mb-3">
                              <label htmlFor="cin">Corporate Identification Number (CIN)</label>
                              <input 
                                type="text" 
                                className="form-control"
                                id="cin" 
                                name="cin" 
                                value={formData.cin} 
                                onChange={handleChange}
                                maxLength="21"
                                placeholder="Enter CIN (alphanumeric only, 21 characters)"
                              />
                            </div>
                          )}
                        </>
                      );
                    } else {
                      return (
                        <div className="col-12 mb-3">
                          <label htmlFor="cin">Corporate Identification Number (CIN)</label>
                          <input 
                            type="text" 
                            className="form-control"
                            id="cin" 
                            name="cin" 
                            value={formData.cin} 
                            onChange={handleChange}
                            maxLength="25"
                            placeholder="Enter CIN (alphanumeric only, max 25 characters)"
                          />
                        </div>
                      );
                    }
                  })()}
                  <div className="col-12 mb-3">
                    <label htmlFor="isoCert">Whether the Unit has ISO Certification, 14000 series (Yes-1, No-2)</label>
                    <select className="form-select" id="isoCert" name="isoCert" value={formData.isoCert} onChange={handleChange}>
                      <option value="" disabled>Select</option>
                      <option value="1">Yes</option>
                      <option value="2">No</option>
                    </select>
                  </div>
                  <div className="col-12 mb-3">
                    <label htmlFor="yearOfInitialProd">Year of Initial Production</label>
                    <input type="text" className="form-control" id="yearOfInitialProd" name="yearOfInitialProd" value={formData.yearOfInitialProd} onChange={handleChange} maxLength="8" />
                  </div>
                  <div className="col-12 mb-3">
                    <label>Accounting Year (MMYY to MMYY)</label>
                  

                    <div className="d-flex gap-3 mb-3">
                      <div className="col-xl-3 col-lg-5 col-md-5 col-sm-6 col-12">
                        <DatePicker
                          className="form-control calendar_icon"
                          selected={startDate}
                          onChange={handleStartDateChange}
                          dateFormat="MMM yyyy"
                          showMonthYearPicker
                          placeholderText="From Date"
                          maxDate={today}
                        />
                      </div>
                      <span className="align-self-center">to</span>
                      <div className="col-xl-4 col-lg-5 col-md-5 col-sm-6 col-12">
                        <DatePicker
                          className="form-control calendar_icon"
                          selected={endDate}
                          onChange={handleEndDateChange}
                          dateFormat="MMM yyyy"
                          showMonthYearPicker
                          placeholderText="To Date"
                          maxDate={today}
                          minDate={startDate} // End date cannot be before start date
                        />
                      </div>
                    </div>

                  </div>
                  <div className="col-12 mb-3">
                    <label htmlFor="monthsOfOperation">No of Months of Operation</label>
                    <input
                      type="text"
                      className="form-control"
                      id="monthsOfOperation"
                      name="monthsOfOperation"
                      value={formData.monthsOfOperation}
                      maxLength="3"
                      onChange={(e) => {
                        const value = e.target.value;
                        if (!/^\d*$/.test(value)) {
                          toast.error('Please enter a valid number for months of operation', messages.COLOR_RED);
                          return;
                        }
                        setFormData({ ...formData, monthsOfOperation: value });
                      }}
                    />
                  </div>
                  
                  
                  {(() => {
                    const is2024Year = !formData.year || formData.year.startsWith('2024');
                    const showRdEmployees = is2024Year && (formData.rdUnit === '1' || formData.rdUnit === '2');
                    
                    if (showRdEmployees) {
                      return (
                        <>
                          <div className="col-12 mb-2 mt-3">
                            <h6 className="fw-semibold text-muted">If yes & registered with DSIR - 1 or yes & registered with others - 2, in item no 9, number of employees engaged in R&D activity</h6>
                          </div>
                          <div className="col-12 mb-3">
                            <label htmlFor="rdMaleEmployees">9.1 Male</label>
                            <input 
                              type="text" 
                              className="form-control"
                              id="rdMaleEmployees"
                              name="rdMaleEmployees"
                              maxLength="6"
                              value={formData.rdMaleEmployees}
                              onChange={handleChange}
                              placeholder="Number of employees"
                            />
                          </div>
                          <div className="col-12 mb-3">
                            <label htmlFor="rdFemaleEmployees">9.2 Female</label>
                            <input 
                              type="text" 
                              className="form-control"
                              id="rdFemaleEmployees"
                              name="rdFemaleEmployees"
                              maxLength="6"
                              value={formData.rdFemaleEmployees}
                              onChange={handleChange}
                              placeholder="Number of employees"
                            />
                          </div>
                          <div className="col-12 mb-3">
                            <label htmlFor="rdTransgenderEmployees">9.3 Transgender</label>
                            <input 
                              type="text" 
                              className="form-control"
                              id="rdTransgenderEmployees"
                              name="rdTransgenderEmployees"
                              maxLength="6"
                              value={formData.rdTransgenderEmployees}
                              onChange={handleChange}
                              placeholder="Number of employees"
                            />
                          </div>
                        </>
                      );
                    }
                    return null;
                  })()}
                </div>
              </div>
            </div>

     

            

            {(() => {
              const is2024Year = !formData.year || formData.year.startsWith('2024');
              if (!is2024Year) {
                return (
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label>Fax No.</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder=""
                        name="contactFax"
                        value={formData.contactFax}
                        onChange={(e) => {
                          const value = e.target.value;
                          const allowedPattern = /^[+\d-]*$/;

                          if (allowedPattern.test(value) || value === '') {
                            const cleanedValue = value.replace(/[-]+/g, '-');
                            setFormData({ ...formData, contactFax: cleanedValue });
                          } else {
                            toast.error('Only numbers, + and - are allowed', messages.COLOR_RED);
                          }
                        }}
                        onBlur={(e) => {
                          const value = e.target.value;
                          if (value && value.trim() !== '') {
                            const digitCount = (value.match(/\d/g) || []).length;
                            if (digitCount < 10) {
                              toast.error('Fax number should be at least 10 digits', messages.COLOR_RED);
                            }
                          }
                        }}
                        maxLength="20"
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label>E-Mail</label>
                      <input 
                        type="email" 
                        className={`form-control ${errors.contactEmail ? 'is-invalid' : ''}`} 
                        placeholder="Enter valid email address" 
                        name="contactEmail" 
                        value={formData.contactEmail} 
                        onChange={handleChange} 
                        maxLength="55"
                      />
                      {errors.contactEmail && (
                        <div className="invalid-feedback">
                          {errors.contactEmail}
                        </div>
                      )}
                    </div>
                  </div>
                );
              }
              return null;
            })()}

            

            <br />



           
          </div>

        </div> */}
      <div className="mx-3">
        <div className="row">
          <div className="col-12">
            <hr />
          </div>
          <div className="col-md-8 text-center text-md-start mb-3 mb-md-0">
            <button
              type="button"
              className="btn btn_orange mx-1"
              onClick={() => window.print()}
            >
              Print
              <i className="fa fa-print ms-1"></i>
            </button>
            <button
              type="button"
              className="btn btn_orange mx-1"
              onClick={() => {
                if (buttonClickRef.current.isProcessing) {
                  return;
                }
                buttonClickRef.current.isProcessing = true;

                if (!validateDSLMandatory()) {
                  buttonClickRef.current.isProcessing = false;
                  return;
                }
                if (!validateDateRange()) {
                  buttonClickRef.current.isProcessing = false;
                  return;
                }
                handleSaveCompleteAsiFrame().finally(() => {
                  buttonClickRef.current.isProcessing = false;
                });
              }}
            >
              Save
            </button>
            <button
              type="button"
              className="btn btn_orange mx-1"
              onClick={handleReset}
            >
              Reset
            </button>
            <button
              type="button"
              className="btn btn_orange mx-1"
              onClick={() => window.location.href = '/dashboard'}
            >
              Cancel
            </button>
          </div>
          <div className="col-md-4 text-center text-md-end">
            <button
              type="button"
              className="btn btn_orange mx-1"
              onClick={async () => {
                if (buttonClickRef.current.isProcessing) {
                  return;
                }
                buttonClickRef.current.isProcessing = true;

                if (!validateDSLMandatory()) {
                  buttonClickRef.current.isProcessing = false;
                  return;
                }

                if (!validateDateRange()) {
                  buttonClickRef.current.isProcessing = false;
                  return;
                }

                const emailError = validateEmail(formData.contactEmail);
                if (emailError) {
                  setErrors(prev => ({ ...prev, contactEmail: emailError }));
                  const toastKey = 'next-email-error';
                  if (!toastShownRef.current[toastKey]) {
                    toast.error(emailError, messages.COLOR_RED);
                    toastShownRef.current[toastKey] = true;
                    setTimeout(() => delete toastShownRef.current[toastKey], 3000);
                  }
                  buttonClickRef.current.isProcessing = false;
                  return;
                }


                const saveSuccess = await handleSaveCompleteAsiFrame();

                if (saveSuccess) {
                  setTimeout(() => {
                    navigate('/fixedAssets');
                  }, 1500);
                } else {
                  buttonClickRef.current.isProcessing = false;
                }
              }}
            >
              Next
              <i className="fa fa-angle-right ms-1"></i>
            </button>
          </div>
        </div>
      </div>
      <div className='mx-3'>
        <Remarks__list
          remarksData={useMemo(() => {
            // Create remarksData object from formData for filtering
            const remarksData = {
              remarksBlock: formData.remarksBlock || '',
              remarksItems: formData.remarksItems || ''
            };
            return filterRemarksList(remarksList, remarksData);
          }, [remarksList, formData.remarksBlock, formData.remarksItems])}
        />
      </div>


      {/* Toast Container for notifications */}
      {/* <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      /> */}
    </>
  );
}

export default BalanceSheet;
